/* ============================================================
   hellodpe — front-end behaviors
   Ported from the prototype. All handlers are defensive: they
   no-op until the matching section markup exists on the page,
   and re-init on Shopify section render (theme editor).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- POSTCODE CHECKER ----------
     Zones come from the hero section's data-hd-zones attribute
     (built from theme-editor blocks), NOT a hardcoded JS object,
     so the client can edit coverage without touching code.
     Expected JSON: { "31000": "Toulouse Centre · Zone A", ... } */
  function initChecker(root) {
    var forms = (root || document).querySelectorAll('[data-hd-checker]');
    forms.forEach(function (form) {
      if (form.dataset.hdBound) return;
      form.dataset.hdBound = '1';

      var wrap = form.closest('[data-hd-zones]') || form;
      var zones = {};
      try { zones = JSON.parse(wrap.getAttribute('data-hd-zones') || '{}'); } catch (e) { zones = {}; }

      var result = form.parentElement.querySelector('[data-hd-checker-result]');
      var target = form.getAttribute('data-hd-target') || '#tarifs';
      var contact = form.getAttribute('data-hd-contact') || '#contact';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        var cp = (input ? input.value : '').trim();
        if (!result) return;
        result.className = 'hd-checker-result show';
        if (zones[cp]) {
          result.classList.add('success');
          var zoneLabel = zones[cp];
          var zoneExtra = (typeof zoneLabel === 'string' && zoneLabel !== 'true')
            ? ' (' + zoneLabel + ')'
            : '';
          result.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="color:var(--ink)"><polyline points="20 6 9 17 4 12"/></svg>' +
            '<div><strong>Parfait.</strong> Nous intervenons dans votre secteur' + zoneExtra +
            '. <a href="' + target + '" style="color:var(--blue);font-weight:600;margin-left:4px;">Choisir un diagnostic →</a></div>';
        } else {
          result.classList.add('error');
          result.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
            '<div>Nous ne couvrons pas encore ce code postal. <a href="' + contact + '" style="color:var(--blue);font-weight:600;">Laissez-nous votre contact →</a></div>';
        }
      });
    });
  }

  /* ---------- AUDIENCE TABS ---------- */
  function initAudienceTabs(root) {
    var groups = (root || document).querySelectorAll('[data-hd-aud-group]');
    groups.forEach(function (group) {
      if (group.dataset.hdBound) return;
      group.dataset.hdBound = '1';
      group.querySelectorAll('[data-hd-aud-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-hd-aud-tab');
          group.querySelectorAll('[data-hd-aud-tab]').forEach(function (t) { t.classList.remove('active'); });
          group.querySelectorAll('[data-hd-aud-panel]').forEach(function (p) { p.classList.remove('active'); });
          tab.classList.add('active');
          var panel = group.querySelector('[data-hd-aud-panel="' + key + '"]');
          if (panel) panel.classList.add('active');
        });
      });
    });
  }

  /* ---------- FAQ ACCORDION (one open at a time, height animated) ---------- */
  function initFaq(root) {
    var wraps = (root || document).querySelectorAll('[data-hd-faq]');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.hdBound) return;
      wrap.dataset.hdBound = '1';
      var items = wrap.querySelectorAll('.hd-faq-item');
      wrap.querySelectorAll('.hd-faq-q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.parentElement;
          var answer = item.querySelector('.hd-faq-a');
          var isOpen = item.classList.contains('open');
          items.forEach(function (i) {
            i.classList.remove('open');
            var a = i.querySelector('.hd-faq-a');
            if (a) a.style.maxHeight = null;
          });
          if (!isOpen && answer) {
            item.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        });
      });
      var first = wrap.querySelector('.hd-faq-item.open .hd-faq-a');
      if (first) first.style.maxHeight = first.scrollHeight + 'px';
    });
  }

  /* ---------- REVEAL ON SCROLL ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hd-reveal:not([data-hd-reveal-bound])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); el.dataset.hdRevealBound = '1'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.dataset.hdRevealBound = '1'; io.observe(el); });
  }

  /* ---------- MOBILE NAV DRAWER ---------- */
  function initMobileMenu(root) {
    var toggles = (root || document).querySelectorAll('[data-hd-menu-toggle]');
    toggles.forEach(function (btn) {
      if (btn.dataset.hdBound) return;
      btn.dataset.hdBound = '1';
      var header = btn.closest('[data-hd-header]');
      var menu = header ? header.querySelector('[data-hd-mobile-menu]') : null;
      if (!menu) return;
      var overlay = header.querySelector('[data-hd-mobile-overlay]');
      var closeBtn = header.querySelector('[data-hd-mobile-close]');

      function setOpen(open) {
        menu.classList.toggle('open', open);
        if (overlay) overlay.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.style.overflow = open ? 'hidden' : '';
        if (open && closeBtn) {
          closeBtn.focus();
        } else if (!open) {
          btn.focus();
        }
      }

      btn.addEventListener('click', function () {
        setOpen(!menu.classList.contains('open'));
      });
      if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
      if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && menu.classList.contains('open')) {
          setOpen(false);
        }
      });
    });
  }

  /* ---------- SLIDER (scroll-snap + arrows + dots) ---------- */
  function initSlider(root) {
    (root || document).querySelectorAll('[data-hd-slider]').forEach(function (slider) {
      if (slider.dataset.hdBound) return;
      slider.dataset.hdBound = '1';
      var track = slider.querySelector('[data-hd-slider-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;
      var prev = slider.querySelector('[data-hd-slider-prev]');
      var next = slider.querySelector('[data-hd-slider-next]');
      var dotsWrap = slider.querySelector('[data-hd-slider-dots]');
      var dots = [];

      if (dotsWrap) {
        cards.forEach(function (card, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Aller à l’avis ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function step() {
        return cards[0].getBoundingClientRect().width + 20;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      function update() {
        var i = Math.round(track.scrollLeft / step());
        if (i < 0) i = 0;
        if (i > cards.length - 1) i = cards.length - 1;
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }
      var raf;
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(update);
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- BOOKING pick-card groups (single-select per group) ---------- */
  function fmtDuration(min) {
    if (!min) return '—';
    var h = Math.floor(min / 60), m = min % 60;
    if (h === 0) return m + ' min';
    return m === 0 ? h + ' h' : h + ' h ' + (m < 10 ? '0' + m : m);
  }
  function syncBookingRecapFromCatalog(scope, section) {
    if (!section) return;
    var catalogUrl = section.getAttribute('data-catalog-url');
    if (!catalogUrl) return;
    fetchHdCatalog(catalogUrl).then(function (catalog) {
      if (!catalog) return;
      var packCard = scope.querySelector('[data-hd-pick][data-group="pack"].active');
      var surfaceCard = scope.querySelector('[data-hd-pick][data-group="surface"].active');
      if (!packCard) return;
      var packKey = packCard.getAttribute('data-map-key') || packCard.getAttribute('data-label');
      var sk = surfaceKeyFromCard(surfaceCard, catalog);
      var price = catalogPriceForSelection(packKey, sk, catalog, packCard);
      if (price != null) {
        packCard.setAttribute('data-price', String(price));
        updateBookingRecap(scope);
      }
    });
  }

  function updateBookingRecap(scope) {
    var recap = scope.querySelector('[data-hd-recap]');
    if (!recap) return;
    var pack = '', surface = '', minutes = 0, price = 0, hasPrice = false;
    scope.querySelectorAll('.pick-card.active').forEach(function (c) {
      var grp = c.getAttribute('data-group');
      var label = c.getAttribute('data-label') || '';
      if (grp === 'pack') pack = label;
      if (grp === 'surface') surface = label;
      var mn = parseFloat(c.getAttribute('data-minutes'));
      if (!isNaN(mn)) minutes += mn;
      var pr = parseFloat(c.getAttribute('data-price'));
      if (!isNaN(pr)) { price += pr; hasPrice = true; }
    });
    var cur = recap.getAttribute('data-currency') || '€';
    var noPrice = recap.getAttribute('data-no-price') || 'Sur devis';
    var freeLabel = recap.getAttribute('data-free-label') || 'Offert';
    var threshold = parseFloat(recap.getAttribute('data-free-threshold')) || 0;
    var fee = parseFloat(recap.getAttribute('data-travel-fee')) || 0;
    function set(key, val) {
      var el = recap.querySelector('[data-hd-recap="' + key + '"]');
      if (el) el.textContent = val;
    }
    set('pack', pack || '—');
    set('surface', surface || '—');
    set('duration', fmtDuration(minutes));
    var travelEl = recap.querySelector('[data-hd-recap="travel"]');
    if (hasPrice) {
      var free = price >= threshold;
      set('subtotal', price + ' ' + cur);
      if (travelEl) {
        travelEl.textContent = free ? freeLabel : '+ ' + fee + ' ' + cur;
        travelEl.classList.toggle('is-free', free);
      }
      set('total', (free ? price : price + fee) + ' ' + cur);
    } else {
      set('subtotal', noPrice);
      if (travelEl) { travelEl.textContent = '—'; travelEl.classList.remove('is-free'); }
      set('total', noPrice);
    }
  }
  function initBooking(root) {
    (root || document).querySelectorAll('[data-hd-pick-group]').forEach(function (group) {
      if (group.dataset.hdBound) return;
      group.dataset.hdBound = '1';
      var layout = group.closest('.reservation-layout') || group.closest('.hd') || document;
      var cards = group.querySelectorAll('.pick-card');
      cards.forEach(function (card) {
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        function choose() {
          cards.forEach(function (c) { c.classList.remove('active'); });
          card.classList.add('active');
          updateBookingRecap(layout);
          var section = layout.closest('[data-hd-booking-section]');
          if (section) syncBookingRecapFromCatalog(layout, section);
        }
        card.addEventListener('click', choose);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
      });
      updateBookingRecap(layout);
    });
    bindBookingSurfaceSync(root);
    initBookingCheckout(root);
    initBookingDeepLink(root);
  }

  function initBookingDeepLink(root) {
    (root || document).querySelectorAll('[data-hd-booking-section]').forEach(function (section) {
      if (section.dataset.hdDeepLink) return;
      section.dataset.hdDeepLink = '1';
      try {
        var p = new URLSearchParams(window.location.search);
        var pack = p.get('pack');
        var surface = p.get('surface');
        var layout = section.querySelector('.reservation-layout');
        if (!layout) return;
        if (pack) {
          layout.querySelectorAll('[data-hd-pick][data-group="pack"]').forEach(function (c) {
            var key = c.getAttribute('data-map-key') || '';
            if (key === pack) {
              c.classList.add('active');
              layout.querySelectorAll('[data-hd-pick][data-group="pack"]').forEach(function (o) {
                if (o !== c) o.classList.remove('active');
              });
            }
          });
        }
        if (surface) {
          layout.querySelectorAll('[data-hd-pick][data-group="surface"]').forEach(function (c) {
            var key = c.getAttribute('data-map-key') || c.getAttribute('data-label') || '';
            if (key === surface || normBookingLabel(key) === normBookingLabel(surface)) {
              c.classList.add('active');
              layout.querySelectorAll('[data-hd-pick][data-group="surface"]').forEach(function (o) {
                if (o !== c) o.classList.remove('active');
              });
            }
          });
        }
        updateBookingRecap(layout);
        syncBookingRecapFromCatalog(layout, section);
      } catch (e) { /* ignore */ }
    });
  }

  function bindBookingSurfaceSync(root) {
    (root || document).querySelectorAll('[data-hd-booking-section]').forEach(function (section) {
      if (section.dataset.hdSyncBound) return;
      section.dataset.hdSyncBound = '1';
      var catalogUrl = section.getAttribute('data-catalog-url');
      if (!catalogUrl) return;
      fetchHdCatalog(catalogUrl).then(function (catalog) {
        if (!catalog) return;
        section.querySelectorAll('[data-hd-pick][data-group="surface"]').forEach(function (card) {
          card.addEventListener('click', function () {
            var sk = card.getAttribute('data-surface-key') || surfaceKeyFromCard(card, catalog);
            if (!sk) return;
            var pack = (catalog.booking_packs || []).find(function (p) {
              return p.surfaces && p.surfaces.indexOf(sk) >= 0 && p.handle && !p.devis;
            });
            var layout = section.querySelector('.reservation-layout');
            if (!layout) return;
            var hadActivePack = !!layout.querySelector('[data-hd-pick][data-group="pack"].active');
            layout.querySelectorAll('[data-hd-pick][data-group="pack"]').forEach(function (c) {
            var isMatch = hadActivePack && pack && c.getAttribute('data-map-key') === pack.key;
            c.classList.toggle('active', isMatch);
            var pe = (catalog.booking_packs || []).find(function (p) { return p.key === c.getAttribute('data-map-key'); });
            var compatible = !pe || !pe.surfaces || pe.surfaces.indexOf(sk) >= 0;
            c.classList.toggle('is-disabled', !compatible);
            c.setAttribute('aria-disabled', compatible ? 'false' : 'true');
            c.style.pointerEvents = compatible ? '' : 'none';
          });
          updateBookingRecap(layout);
        });
        });
      });
    });
  }

  function sqmToSurfaceKey(sqm) {
    if (sqm <= 29) return 's29';
    if (sqm <= 89) return 's30_89';
    if (sqm <= 149) return 's90_149';
    if (sqm <= 249) return 's150_249';
    return 's250';
  }

  function servicePriceFromCatalog(catalog, serviceId, surfaceKey) {
    var s = catalogServiceById(catalog, serviceId);
    if (!s) return null;
    if (s.prices && surfaceKey && s.prices[surfaceKey]) {
      return s.prices[surfaceKey].devis ? null : s.prices[surfaceKey].price;
    }
    if (s.devis || s.price === 0) return null;
    return s.price != null ? s.price : null;
  }function servicePriceStartingFrom(catalog, serviceId) {
  var s = catalogServiceById(catalog, serviceId);
  if (!s || !s.prices) return null;
  var min = null;
  Object.keys(s.prices).forEach(function (k) {
    var row = s.prices[k];
    if (row.devis || row.price == null) return;
    if (min == null || row.price < min) min = row.price;
  });
  return min;
}

  function catalogPackPrice(entry, surfaceKey) {
    if (!entry) return null;
    if (entry.devis || entry.funnel === 'devis') return null;
    if (entry.prices && entry.prices[surfaceKey]) {
      var row = entry.prices[surfaceKey];
      if (row.devis || row.price == null || row.price <= 0) return null;
      return row.price;
    }
    if (entry.price != null && entry.price > 0) return entry.price;
    return null;
  }

  function hdCatalogTravelConfig(catalog, extra) {
    var cfg = {
      free_threshold: (catalog && catalog.free_threshold) || 139,
      travel_fee: (catalog && (catalog.travel_fee || (catalog.travel_fee_product && catalog.travel_fee_product.amount))) || 59,
      travel_fee_product_handle: (catalog && catalog.travel_fee_product && catalog.travel_fee_product.handle) || 'frais-de-deplacement'
    };
    return hdTravelConfig(Object.assign({}, catalog || {}, cfg, extra || {}));
  }

  function sanitizeHelloDpeCatalog(catalog) {
    if (!catalog) return catalog;
    if (Array.isArray(catalog.services)) catalog.services = catalog.services.filter(function (service) { return service.id !== 'assainissement' && service.handle !== 'diagnostic-assainissement'; });
    if (Array.isArray(catalog.pricing_categories)) catalog.pricing_categories.forEach(function (category) {
      if (Array.isArray(category.services_filter)) category.services_filter = category.services_filter.filter(function (id) { return id !== 'assainissement'; });
    });
    if (Array.isArray(catalog.devis_steps)) catalog.devis_steps.forEach(function (step) {
      if (Array.isArray(step.choices)) step.choices = step.choices.filter(function (choice) { return choice.id !== 'assainissement'; });
    });
    return catalog;
  }

  function normBookingLabel(s) {
    return (s || '').toLowerCase().replace(/[àáâãäå]/g, 'a').replace(/[èéêë]/g, 'e')
      .replace(/≤/g, '').replace(/≥/g, '').replace(/–/g, '-').replace(/—/g, '-')
      .replace(/m²/g, 'm2').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  var _hdCatalogCache = null;
  var _hdProductCache = {};

  function fetchHdCatalog(url) {
    if (_hdCatalogCache) return Promise.resolve(_hdCatalogCache);
    if (window.__HD_PRODUCT_CATALOG) {
      _hdCatalogCache = sanitizeHelloDpeCatalog(window.__HD_PRODUCT_CATALOG);
      return Promise.resolve(_hdCatalogCache);
    }
    if (!url) return Promise.resolve(null);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        if (!d || !Array.isArray(d.booking_packs)) throw new Error('Invalid catalog');
        _hdCatalogCache = sanitizeHelloDpeCatalog(d);
        return d;
      })
      .catch(function () { return null; });
  }

  function fetchShopifyProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (_hdProductCache[handle]) return Promise.resolve(_hdProductCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('Produit introuvable'); return r.json(); })
      .then(function (p) { _hdProductCache[handle] = p; return p; })
      .catch(function () { return null; });
  }
  var _hdDurationCache = {};
  function fetchProductDurations(handle) {
    if (!handle) return Promise.resolve({});
    if (_hdDurationCache[handle]) return Promise.resolve(_hdDurationCache[handle]);
    return fetch('/products/' + handle)
      .then(function (r) { if (!r.ok) throw new Error('Page introuvable'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tag = doc.querySelector('[data-hd-product-durations]');
        var data = {};
        if (tag) { try { data = JSON.parse(tag.textContent); } catch (e) { data = {}; } }
        _hdDurationCache[handle] = data;
        return data;
      })
      .catch(function () { return {}; });
  }

  var _hdCalendlyUrlsCache = null;
function fetchCalendlyUrls() {
  if (_hdCalendlyUrlsCache) return Promise.resolve(_hdCalendlyUrlsCache);
  if (!window.HD_CALENDLY_URLS_URL) return Promise.resolve({});
  return fetch(window.HD_CALENDLY_URLS_URL)
    .then(function (r) { return r.json(); })
    .then(function (d) { _hdCalendlyUrlsCache = d; return d; })
    .catch(function () { return {}; });
}

  function minutesToTier(mins) {
    if (mins <= 60) return '1H';
    if (mins <= 75) return '1H15';
    if (mins <= 90) return '1H30';
    if (mins <= 120) return '2H';
    if (mins <= 150) return '2H30';
    if (mins <= 180) return '3H';
    if (mins <= 240) return '4H';
    if (mins <= 300) return '5H';
    return 'JOURNEE';
  }

  function resolveCalendlyLink(postcode, totalMinutes) {
  if (!window.HD_CALENDLY_MAP_URL) return Promise.resolve(null);
  return fetch(window.HD_CALENDLY_MAP_URL)
    .then(function (r) { return r.json(); })
    .then(function (zoneMap) {
      var entry = zoneMap.postcode_index && zoneMap.postcode_index[postcode];
      if (!entry) return null;
      var zonePrefix = entry.region === 'toulouse' ? 'Z' + entry.zone + 'T' : entry.zone;
      var tier = minutesToTier(totalMinutes);
      return fetchCalendlyUrls().then(function (urls) {
        return urls[zonePrefix + '|' + tier] || null;
      });
    }).catch(function () { return null; });
}

  function hdTravelConfig(source) {
    source = source || {};
    return {
      free_threshold: source.free_threshold || 139,
      travel_fee: source.travel_fee || 59,
      handle: (source.travel_fee_product && source.travel_fee_product.handle)
        || source.travel_fee_product_handle
        || 'frais-de-deplacement'
    };
  }

  function resolveTravelFeeVariantId(config) {
    var cfg = hdTravelConfig(config);
    return fetchShopifyProduct(cfg.handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      return variant ? variant.id : null;
    });
  }

  function needsTravelFee(subtotalEuros, config) {
    var cfg = hdTravelConfig(config);
    return subtotalEuros > 0 && subtotalEuros < cfg.free_threshold;
  }

  function buildCartItemsWithTravelFee(mainVariantId, subtotalEuros, props, config) {
  var items = [{ id: mainVariantId, quantity: 1, properties: props || {} }];
  if (!needsTravelFee(subtotalEuros, config)) return Promise.resolve(items);
  var cfg = hdTravelConfig(config);
  var feeAmount = Math.max(1, Math.round(cfg.free_threshold - subtotalEuros));
  return resolveTravelFeeVariantId(config).then(function (feeId) {
    if (feeId) {
      items.push({
        id: feeId,
        quantity: feeAmount,
        properties: { _type: 'travel_fee', 'Note': 'Frais de déplacement (' + feeAmount + ' €) — offerts dès ' + cfg.free_threshold + ' € d\'achat' }
      });
    }
    return items;
  });
}

  function buildMultiCartItemsWithTravelFee(variantIds, subtotalEuros, props, config) {
    var baseProps = props || {};
    var items = (variantIds || []).filter(Boolean).map(function (id) {
      return { id: id, quantity: 1, properties: Object.assign({}, baseProps) };
    });
    if (!items.length) return Promise.resolve(null);
    if (!needsTravelFee(subtotalEuros, config)) return Promise.resolve(items);
    return resolveTravelFeeVariantId(config).then(function (feeId) {
      if (feeId) {
        var feeAmount = Math.max(1, Math.round(hdTravelConfig(config).free_threshold - subtotalEuros));
        items.push({
          id: feeId,
          quantity: feeAmount,
          properties: { _type: 'travel_fee', 'Note': 'Complément exact au minimum d’intervention de ' + hdTravelConfig(config).free_threshold + ' €' }
        });
      }
      return items;
    });
  }

  function hdDossierReference() {
    var now = new Date();
    var y = String(now.getFullYear());
    var m = String(now.getMonth() + 1).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var token = '';
    var bytes = null;
    try {
      bytes = new Uint8Array(6);
      window.crypto.getRandomValues(bytes);
    } catch (e) {}
    for (var i = 0; i < 6; i += 1) {
      var n = bytes ? bytes[i] : Math.floor(Math.random() * 256);
      token += alphabet.charAt(n % alphabet.length);
    }
    return 'HD-' + y + m + d + '-' + token;
  }

  function hdPrepareDossierItems(items, reference) {
    var visibleReferenceAdded = false;
    return (items || []).map(function (item) {
      var copy = Object.assign({}, item);
      copy.properties = Object.assign({}, item.properties || {});
      copy.properties._dossier_ref = reference;
      if (!visibleReferenceAdded && copy.properties._type !== 'travel_fee') {
        copy.properties['Référence dossier'] = reference;
        visibleReferenceAdded = true;
      }
      return copy;
    });
  }

  function hdPersistBookingContext(reference, requestedItems, responseData) {
    var responseItems = responseData && Array.isArray(responseData.items) ? responseData.items : [];
    var sourceItems = responseItems.length ? responseItems : (requestedItems || []);
    var services = sourceItems.filter(function (item) {
      return !(item.properties && item.properties._type === 'travel_fee');
    }).map(function (item) {
      var product = item.product_title || item.title || '';
      var variant = item.variant_title || '';
      if (variant && variant !== 'Default Title' && product.indexOf(variant) < 0) product += ' — ' + variant;
      return product;
    }).filter(Boolean);

    var first = (requestedItems || []).find(function (item) {
      return !(item.properties && item.properties._type === 'travel_fee');
    }) || requestedItems[0] || {};
    var props = first.properties || {};
    var context = {
      reference: reference,
      services: services.join(' + '),
      first_name: props['Prénom'] || '',
      last_name: props['Nom'] || '',
      email: props['Email'] || '',
      phone: props['Téléphone'] || '',
      address: props['Adresse'] || '',
      postcode: props['Code postal'] || '',
      city: props['Ville'] || '',
      created_at: new Date().toISOString()
    };
    context.name = [context.first_name, context.last_name].filter(Boolean).join(' ');
    try {
      sessionStorage.setItem('hd_dossier_reference', reference);
      sessionStorage.setItem('hd_booking_context', JSON.stringify(context));
    } catch (e) {}
  }

  function hdCartAddJson(items) {
    var dossierReference = hdDossierReference();
    var dossierItems = hdPrepareDossierItems(items, dossierReference);
    var cartAdd = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (cartAdd.indexOf('.js') < 0) cartAdd = cartAdd.replace(/\/?$/, '') + '.js';
    return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .catch(function () { return null; })
      .then(function () {
        return fetch(cartAdd, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: dossierItems })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!(data && data.status && data.description)) {
          hdPersistBookingContext(dossierReference, dossierItems, data);
        }
        return data;
      });
  }

  function isManualContactHandle(handle) {
    if (!handle) return false;
    var h = handle.toLowerCase();
    return h.indexOf('copro') >= 0 || h.indexOf('mdb') >= 0 || h.indexOf('marchands-de-biens') >= 0;
  }

  function manualContactProps(catalog, productHandle) {
    var handles = (catalog && catalog.manual_contact && catalog.manual_contact.handles) || [];
    if (handles.indexOf(productHandle) >= 0 || isManualContactHandle(productHandle)) {
      return { _routing: 'manual' };
    }
    return {};
  }

  var _hdZonesCache = null;
  function fetchHdZones(url) {
    if (_hdZonesCache) return Promise.resolve(_hdZonesCache);
    if (!url) return Promise.resolve({});
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        _hdZonesCache = (d && d.postcode_index) ? d.postcode_index : {};
        return _hdZonesCache;
      })
      .catch(function () { return {}; });
  }

  function isPostcodeCovered(cp, zones) {
    return !!(zones && zones[cp]);
  }

  function shouldBlockPostcode(cp, zones) {
    if (!zones || !Object.keys(zones).length) return false;
    return !isPostcodeCovered(cp, zones);
  }

  var HD_DEVIS_LOGO_PNG = 'data:image/png;base64,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';
  var HD_DEVIS_QUOTE_KEY = 'hd_devis_quote';
  var _jspdfPromise = null;

  function loadJsPdf() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (_jspdfPromise) return _jspdfPromise;
    _jspdfPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.async = true;
      s.onload = function () { resolve(window.jspdf.jsPDF); };
      s.onerror = function () { reject(new Error('PDF indisponible')); };
      document.head.appendChild(s);
    });
    return _jspdfPromise;
  }

  function saveDevisQuote(payload) {
    try { sessionStorage.setItem(HD_DEVIS_QUOTE_KEY, JSON.stringify(payload)); } catch (e) { /* ignore */ }
  }

  function readDevisQuote() {
    try {
      var raw = sessionStorage.getItem(HD_DEVIS_QUOTE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function downloadDevisPdf(quote) {
    if (!quote) return Promise.reject(new Error('Aucun devis'));
    return loadJsPdf().then(function (jsPDF) {
      var doc = new jsPDF({ unit: 'mm', format: 'a4' });
      var margin = 14;
      var pageW = 210;
      var y = 0;

      // The exact hellodpe PNG is embedded, so every downloaded PDF uses the same logo.
      doc.setFillColor(253, 250, 240);
      doc.rect(0, 0, pageW, 32, 'F');
      doc.setFillColor(48, 85, 255);
      doc.rect(0, 30, pageW, 2, 'F');
      doc.addImage(HD_DEVIS_LOGO_PNG, 'PNG', margin, 4, 60, 23.5, 'hellodpe-devis-logo');
      doc.setFontSize(12); doc.setFont(undefined, 'bold'); doc.setTextColor(55, 54, 67);
      doc.text('Estimation indicative TTC', pageW-margin, 17, { align:'right' });
      doc.setFontSize(8); doc.setFont(undefined, 'normal'); doc.setTextColor(100);
      doc.text('Émis le ' + new Date().toLocaleDateString('fr-FR', { day:'numeric', month:'long', year:'numeric' }), pageW-margin, 24, { align:'right' });
      y = 40;
      doc.setTextColor(0);

      if (quote.meta && quote.meta.length) {
        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text('Votre projet', margin, y);
        y += 4;
        doc.setFont(undefined, 'normal');
        for (var m = 0; m < quote.meta.length; m += 2) {
          var pair = quote.meta.slice(m, m + 2);
          var heights = pair.map(function (row, i) {
            var x = i ? 110 : margin;
            var lines = doc.splitTextToSize(row[0] + ' : ' + row[1], i ? 86 : 85);
            doc.setFontSize(8.5); doc.text(lines, x, y + 5);
            return lines.length * 4.5;
          });
          y += Math.max.apply(null, heights) + 5;
        }
        y += 2;
      }

      doc.setDrawColor(220, 220, 228);
      doc.line(margin, y, pageW - margin, y);
      y += 8;
      doc.setFontSize(11);
      doc.setFont(undefined, 'bold');
      doc.text('Détail des prestations', margin, y);
      y += 8;
      doc.setFont(undefined, 'normal');
      doc.setFontSize(10);

      var totalHTAmount = 0;
      (quote.lines || []).forEach(function (line) {
        doc.setFontSize(9);
        var labelLines = doc.splitTextToSize(String(line.label || ''), 126);
        var rowHeight = Math.max(7, labelLines.length * 4.5 + 2);
        if (y + rowHeight > 255) {
          doc.addPage();
          y = 20;
        }
        var priceStr = String(line.price);
        var isSurDevis = /sur devis/i.test(priceStr);
        doc.text(labelLines, margin, y);
        if (isSurDevis) doc.setTextColor(154, 46, 36);
        doc.text(priceStr, pageW - margin, y, { align: 'right' });
        doc.setTextColor(0);
        if (!isSurDevis) {
          var num = parseFloat(priceStr.replace(/[^\d,.-]/g, '').replace(',', '.'));
          if (!isNaN(num)) totalHTAmount += num;
        }
        y += rowHeight;
      });

      if (y + 65 > 258) { doc.addPage(); y = 20; }
      y += 4;
      doc.setDrawColor(230, 255, 75);
      doc.setFillColor(237, 249, 240);
      doc.rect(margin, y - 2, pageW - margin * 2, 12, 'FD');
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(0, 17, 40);
      doc.text('Total estimé : ' + quote.totalLabel, margin + 4, y + 7);
      doc.setTextColor(0);
      doc.setFont(undefined, 'normal');
      y += 18;

      // ── HT / TTC legal breakdown (20% VAT assumed, French requirement) ──
      if (totalHTAmount > 0) {
        var ttcAmount = totalHTAmount;
        var realHTAmount = Math.round((ttcAmount / 1.2) * 100) / 100;
        var vatAmount = Math.round((ttcAmount - realHTAmount) * 100) / 100;
        totalHTAmount = realHTAmount;
        doc.setFontSize(9);
        doc.setTextColor(90);
        doc.text('Sous-total HT : ' + totalHTAmount.toFixed(2).replace('.', ',') + ' €', margin, y);
        doc.text('TVA 20% : ' + vatAmount.toFixed(2).replace('.', ',') + ' €', margin, y + 5);
        doc.setFont(undefined, 'bold');
        doc.text('Total TTC : ' + ttcAmount.toFixed(2).replace('.', ',') + ' €', margin, y + 10);
        doc.setFont(undefined, 'normal');
        doc.setTextColor(0);
        y += 18;
      }

      if (quote.travelNote) {
        doc.setFontSize(9);
        doc.setTextColor(80);
        var travelLines = doc.splitTextToSize(quote.travelNote, pageW - margin * 2);
        doc.text(travelLines, margin, y);
        y += travelLines.length * 5 + 4;
      }

      // ── LEGAL FOOTER: trade name, SIRET, address ──
      doc.setFontSize(8);
      doc.setTextColor(110);
      var foot = 'Montant indicatif, non contractuel. Un diagnostiqueur certifié HelloDPE valide votre dossier sous 24 h ouvrées.';
      doc.text(doc.splitTextToSize(foot, pageW - margin * 2), margin, 273);

      doc.setDrawColor(220, 220, 228);
      doc.line(margin, 279, pageW - margin, 279);
      doc.setFontSize(7.5);
      doc.setTextColor(130);
      doc.text('HelloDPE — nom commercial de PATRIMOME · 40 chemin du Vallon, 31400 Toulouse · SIREN 988 304 119', margin, 284);
      doc.text('06 70 66 76 17 · hellodpe@gmail.com', pageW - margin, 289, { align: 'right' });

      var fname = 'devis-hellodpe-' + new Date().toISOString().slice(0, 10) + '.pdf';
      doc.save(fname);
    });
  }

  function surfaceKeyFromCard(surfaceCard, catalog) {
    if (!surfaceCard) return null;
    var key = surfaceCard.getAttribute('data-surface-key');
    if (key) return key;
    var label = surfaceCard.getAttribute('data-label') || '';
    var tiers = (catalog && catalog.surface_tiers) || [];
    var norm = normBookingLabel(label);
    var found = tiers.find(function (t) {
      return normBookingLabel(t.label) === norm || (t.aliases || []).some(function (a) { return normBookingLabel(a) === norm; });
    });
    return found ? found.key : null;
  }

  function resolvePackEntry(packKey, surfaceKey, catalog, packCard) {
    var packs = (catalog && catalog.booking_packs) || [];
    var entry = packs.find(function (p) { return p.key === packKey; });
    if (!entry) {
      var copro = (catalog && catalog.copro_products) || [];
      entry = copro.find(function (c) { return c.key === packKey; });
      if (entry) entry = Object.assign({ devis: true, funnel: 'devis' }, entry);
    }
    if (!entry) return null;
    if (packCard && packCard.getAttribute('data-product-handle')) {
      entry = Object.assign({}, entry, { handle: packCard.getAttribute('data-product-handle') });
    }
    if (surfaceKey && entry.surfaces && entry.surfaces.indexOf(surfaceKey) < 0 && !entry.variant_axis) {
      var alt = packs.find(function (p) {
        return p.surfaces && p.surfaces.indexOf(surfaceKey) >= 0 && p.handle && !p.devis;
      });
      if (alt) entry = alt;
    }
    return entry;
  }

  function pickVariantFromProduct(product, surfaceLabel) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (product.variants.length === 1) return product.variants[0];
    var surf = normBookingLabel(surfaceLabel);
    var match = product.variants.find(function (v) {
      var parts = [v.option1, v.option2, v.option3, v.title].filter(Boolean);
      return parts.some(function (p) {
        var n = normBookingLabel(p);
        return n === surf || n.indexOf(surf) >= 0 || surf.indexOf(n) >= 0;
      });
    });
    return match || product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }

  function resolveBookingVariantId(packKey, surfaceLabel, surfaceKey, catalog, packCard) {
    if (packCard && packCard.getAttribute('data-variant-id')) {
      return Promise.resolve(parseInt(packCard.getAttribute('data-variant-id'), 10));
    }
    var entry = resolvePackEntry(packKey, surfaceKey, catalog, packCard);
    if (!entry) return Promise.resolve(null);
    if (entry.funnel === 'tarifs') return Promise.resolve({ redirect: '/pages/tarifs' });
    var manualHandle = entry.handle && isManualContactHandle(entry.handle);
    if ((entry.funnel === 'devis' || entry.devis) && !manualHandle) {
      return Promise.resolve({ redirect: '/pages/devis' });
    }
    if (!entry.handle) return Promise.resolve(null);
    return fetchShopifyProduct(entry.handle).then(function (product) {
      if (!product) return null;
      var variant = pickVariantFromProduct(product, surfaceLabel);
      if (!variant) return null;
      if (parseFloat(variant.price) === 0) return { redirect: '/pages/devis' };
      return variant.id;
    });
  }

  function catalogPriceForSelection(packKey, surfaceKey, catalog, packCard) {
    var entry = resolvePackEntry(packKey, surfaceKey, catalog, packCard);
    if (!entry) return null;
    if (entry.devis || entry.price === 0) return null;
    if (entry.variant_axis === 'surface' && entry.prices && surfaceKey && entry.prices[surfaceKey]) {
      var row = entry.prices[surfaceKey];
      return row.devis ? null : row.price;
    }
    if (entry.price != null) return entry.price;
    return null;
  }

  function pickBookingVariant(catalog, packKey, surfaceLabel, packCard) {
    if (packCard && packCard.getAttribute('data-variant-id')) {
      return parseInt(packCard.getAttribute('data-variant-id'), 10);
    }
    var entry = (catalog.packs || []).find(function (p) {
      return p.key === packKey || normBookingLabel(p.title) === normBookingLabel(packKey);
    });
    if (!entry) return null;
    if (entry.variantId) return entry.variantId;
    var variants = entry.variants || [];
    if (!variants.length) return null;
    if (variants.length === 1) return variants[0].id;
    var surf = normBookingLabel(surfaceLabel);
    var match = variants.find(function (v) {
      var vt = normBookingLabel(v.title);
      return vt === surf || vt.indexOf(surf) >= 0 || surf.indexOf(vt) >= 0;
    });
    var chosen = match || variants.find(function (v) { return v.available; }) || variants[0];
    return chosen ? chosen.id : null;
  }

  function initBookingCheckout(root) {
    (root || document).querySelectorAll('[data-hd-booking-checkout]').forEach(function (btn) {
      if (btn.dataset.hdBound) return;
      btn.dataset.hdBound = '1';
      var section = btn.closest('[data-hd-booking-section]');
      if (!section) return;
      var catalogEl = section.querySelector('[data-hd-booking-catalog]');
      var catalog = {};
      try { catalog = JSON.parse(catalogEl ? catalogEl.textContent : '{}'); } catch (e) { catalog = {}; }
      var errEl = section.querySelector('[data-hd-booking-error]');
      var checkoutUrl = section.getAttribute('data-checkout-url') || '/checkout';

      btn.addEventListener('click', function () {
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        var layout = section.querySelector('.reservation-layout');
        var packCard = layout ? layout.querySelector('[data-hd-pick][data-group="pack"].active') : null;
        var surfaceCard = layout ? layout.querySelector('[data-hd-pick][data-group="surface"].active') : null;
        var typeCard = layout ? layout.querySelector('[data-hd-pick][data-group="type"].active') : null;

        if (!typeCard) {
          if (errEl) { errEl.textContent = 'Choisissez le type de bien (étape 1).'; errEl.hidden = false; }
          return;
        }
        if (!surfaceCard) {
          if (errEl) { errEl.textContent = 'Choisissez la surface (étape 2).'; errEl.hidden = false; }
          return;
        }
        if (!packCard) {
          var alacarteSection = document.querySelector('[data-hd-pricing-builder]');
          if (alacarteSection) {
            alacarteSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (errEl) {
              errEl.textContent = 'Choisissez un pack, ou faites votre sélection à la carte ci-dessous.';
              errEl.hidden = false;
            }
            return;
          }
        }

        var cpInp = section.querySelector('#hd-bk-cp');
        var cp = cpInp ? cpInp.value.trim() : '';
        if (!/^\d{5}$/.test(cp)) {
          if (errEl) { errEl.textContent = 'Saisissez un code postal français à 5 chiffres.'; errEl.hidden = false; }
          return;
        }
        var emInp = section.querySelector('#hd-bk-em');
        var em = emInp ? emInp.value.trim() : '';
        if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
          if (errEl) { errEl.textContent = 'Indiquez une adresse email valide.'; errEl.hidden = false; }
          return;
        }
        if (packCard.getAttribute('data-devis-only') === '1') {
          var mk = packCard.getAttribute('data-map-key');
          window.location.href = mk === 'alacarte' ? '/pages/tarifs' : '/pages/devis';
          return;
        }

        var packKey = packCard.getAttribute('data-map-key') || packCard.getAttribute('data-label');
        var surfaceLabel = surfaceCard ? surfaceCard.getAttribute('data-label') : '';
        var catalogUrl = section.getAttribute('data-catalog-url');

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        var zonesUrl = section.getAttribute('data-zones-url');
        var uncoveredUrl = section.getAttribute('data-uncovered-url') || '/pages/uncovered-zone';
        var zonesPromise = zonesUrl ? fetchHdZones(zonesUrl) : Promise.resolve({});
        var catalogPromise = catalogUrl ? fetchHdCatalog(catalogUrl) : Promise.resolve(null);

        zonesPromise.then(function (zones) {
          if (zonesUrl && !isPostcodeCovered(cp, zones)) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            if (errEl) {
              errEl.innerHTML = 'Code postal non couvert. <a href="' + uncoveredUrl + '">Laissez-nous votre contact →</a>';
              errEl.hidden = false;
            }
            return Promise.reject(new Error('zone'));
          }
          return catalogPromise;
        }).then(function (catalog) {
          if (!catalog) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            if (errEl) { errEl.textContent = 'Catalogue tarifs introuvable.'; errEl.hidden = false; }
            return;
          }
          var travelCfg = hdCatalogTravelConfig(catalog, {
            free_threshold: parseFloat(section.getAttribute('data-free-threshold')) || undefined,
            travel_fee_product_handle: section.getAttribute('data-travel-fee-handle') || undefined
          });
          var surfaceKey = surfaceKeyFromCard(surfaceCard, catalog);
          var subtotal = catalogPriceForSelection(packKey, surfaceKey, catalog, packCard);
          if (subtotal == null && packCard) {
            var pv = parseFloat(packCard.getAttribute('data-price-value'));
            if (!isNaN(pv)) subtotal = pv;
          }
          return resolveBookingVariantId(packKey, surfaceLabel, surfaceKey, catalog, packCard)
            .then(function (variantId) { return { variantId: variantId, subtotal: subtotal, catalog: catalog, travelCfg: travelCfg }; });
        }).then(function (ctx) {
          if (ctx.variantId && ctx.variantId.redirect) {
            window.location.href = ctx.variantId.redirect;
            return;
          }
          if (!ctx.variantId) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            if (errEl) {
              errEl.textContent = 'Produit Shopify introuvable pour ce pack. Vérifiez que le handle produit est correct dans le catalogue.';
              errEl.hidden = false;
            }
            return;
          }

          var props = {};
          if (typeCard) props['Type de bien'] = typeCard.getAttribute('data-label') || '';
          if (surfaceLabel) props['Surface'] = surfaceLabel;
          var addr = section.querySelector('#hd-bk-addr');
          var cp = section.querySelector('#hd-bk-cp');
          var city = section.querySelector('#hd-bk-city');
          var fn = section.querySelector('#hd-bk-fn');
          var ln = section.querySelector('#hd-bk-ln');
          var em = section.querySelector('#hd-bk-em');
          var ph = section.querySelector('#hd-bk-ph');
          if (addr && addr.value) props['Adresse'] = addr.value.trim();
          if (cp && cp.value) props['Code postal'] = cp.value.trim();
          if (city && city.value) props['Ville'] = city.value.trim();
          if (fn && fn.value) props['Prénom'] = fn.value.trim();
          if (ln && ln.value) props['Nom'] = ln.value.trim();
          if (em && em.value) props['Email'] = em.value.trim();
          if (ph && ph.value) props['Téléphone'] = ph.value.trim();

          var productHandle = packCard.getAttribute('data-product-handle') || '';
          Object.assign(props, manualContactProps(ctx.catalog, productHandle));

          var feeNeeded = needsTravelFee(ctx.subtotal, ctx.travelCfg);
          return resolveTravelFeeVariantId(ctx.travelCfg).then(function (feeId) {
            if (feeNeeded && !feeId) {
              console.warn('[HelloDPE] Produit frais-de-deplacement introuvable — panier sans frais de déplacement.');
            }
            return buildCartItemsWithTravelFee(ctx.variantId, ctx.subtotal, props, ctx.travelCfg);
          }).then(function (items) { return hdCartAddJson(items); })
            .then(function (data) {
              if (data.status && data.description) throw new Error(data.description);
              var durationPromise = fetchProductDurations(productHandle).then(function (durMap) {
            var mins = durMap[ctx.variantId] || 0;
            var cpField = section.querySelector('#hd-bk-cp');
            var cpVal = cpField ? cpField.value.trim() : '';
            if (mins > 0 && cpVal) {
              return resolveCalendlyLink(cpVal, mins).then(function (link) {
                if (link) { try { sessionStorage.setItem('hd_calendly_link', link); } catch (e) {} }
              });
            }
          }).catch(function () {});
          durationPromise.then(function () {
            window.location.href = checkoutUrl;
          });
            });
        }).catch(function (err) {
          if (err && err.message === 'zone') return;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (errEl) {
            errEl.textContent = err.message || 'Impossible d’ajouter au panier. Vérifiez que le produit est actif et en stock dans Shopify.';
            errEl.hidden = false;
          }
        });
      });
    });
  }

  /* ---------- MOBILE NAV SUBMENU (accordion in drawer) ---------- */
  function initNavSubmenu(root) {
    (root || document).querySelectorAll('[data-hd-submenu-toggle]').forEach(function (btn) {
      if (btn.dataset.hdBound) return;
      btn.dataset.hdBound = '1';
      var group = btn.closest('[data-hd-submenu]');
      if (!group) return;
      btn.addEventListener('click', function () {
        var open = group.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function hdFormatEuro(n) {
    if (n == null || isNaN(n)) return 'Sur devis';
    return Math.round(n) + ' €';
  }

  /* ---------- PRICING TABS (Netflix-style) ---------- */
  function initPricingTabs(root) {
    var sections = (root || document).querySelectorAll('[data-hd-pricing-tabs]');
    sections.forEach(function (sec) {
      if (sec.dataset.hdPricingBound) return;
      sec.dataset.hdPricingBound = '1';
      var mount = sec.querySelector('[data-hd-pricing-mount]');
      var catUrl = sec.getAttribute('data-catalog-url');
      if (!mount || !catUrl) return;

      fetchHdCatalog(catUrl).then(function (catalog) {
        var categories = catalog && catalog.pricing_categories;
        if (!categories || !categories.length) {
          mount.innerHTML = '<p class="hd-pricing-error">Tarifs indisponibles pour le moment.</p>';
          return;
        }
        var booking = sec.getAttribute('data-booking-url') || '/pages/reservation';
        var devis = sec.getAttribute('data-devis-url') || '/pages/devis';
        var firstId = categories[0].id;
        var nav = '<div class="hd-ptab-nav" role="tablist">';
        var panels = '';
        categories.forEach(function (cat) {
          var active = cat.id === firstId ? ' active' : '';
          nav += '<button type="button" class="hd-ptab-btn' + active + '" role="tab" aria-selected="' + (active ? 'true' : 'false') + '" data-hd-ptab="' + cat.id + '">' + cat.label + '</button>';
          panels += renderPricingPanel(cat, catalog, booking, devis, active);
        });
        nav += '</div>';
        mount.innerHTML = nav + '<div class="hd-ptab-panels">' + panels + '</div>';
        mount.removeAttribute('aria-busy');

        mount.querySelectorAll('[data-hd-ptab]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-hd-ptab');
            mount.querySelectorAll('.hd-ptab-btn').forEach(function (b) {
              b.classList.toggle('active', b === btn);
              b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
            });
            mount.querySelectorAll('.hd-ptab-panel').forEach(function (p) {
              p.classList.toggle('active', p.getAttribute('data-hd-ptab-panel') === id);
            });
          });
        });
      });
    });
  }

  function catalogServiceById(catalog, id) {
    if (!catalog || !catalog.services) return null;
    return catalog.services.find(function (s) { return s.id === id; });
  }

  function catalogPackById(catalog, packId) {
    if (!catalog) return null;
    var bp = (catalog.booking_packs || []).find(function (b) { return b.key === packId; });
    if (bp) return bp;
    return (catalog.copro_products || []).find(function (b) { return b.key === packId; });
  }

  function renderPricingPanel(cat, catalog, booking, devis, active) {
    var cls = 'hd-ptab-panel' + (active ? ' active' : '');
    var html = '<div class="' + cls + '" data-hd-ptab-panel="' + cat.id + '" role="tabpanel" id="' + (cat.anchor || cat.id) + '">';

    if (cat.mode === 'cards') {
      html += '<div class="hd-svc-cards">';
      var list = (catalog && catalog.services) ? catalog.services.slice() : [];
      if (cat.services_filter) {
        list = list.filter(function (s) { return cat.services_filter.indexOf(s.id) >= 0; });
      }
      list.forEach(function (svc) {
        var priceVal = servicePriceStartingFrom(catalog, svc.id);
        var price = priceVal != null ? 'dès ' + hdFormatEuro(priceVal) : 'Sur devis';
        var href = svc.url || (priceVal != null ? booking : devis);
        if (priceVal == null) href = devis;
        html += '<article class="hd-svc-card"><span class="hd-svc-tag">' + (svc.tag || '') + '</span><h3>' + svc.name + '</h3><p class="hd-svc-price">' + price + '</p><a class="btn btn-dark btn-sm" href="' + href + '">' + (priceVal == null ? 'Demander un devis' : 'Réserver') + '</a></article>';
      });
      html += '</div></div>';
      return html;
    }

    if (cat.packs && cat.packs.length && cat.surface_rows && cat.surface_rows.length) {
      html += '<div class="hd-ptable-scroll"><table class="hd-ptable"><thead><tr><th>Surface</th>';
      cat.packs.forEach(function (p) {
        html += '<th><span class="hd-ptable-pack">' + p.name + '</span>';
        if (p.tagline) html += '<span class="hd-ptable-tag">' + p.tagline + '</span>';
        html += '</th>';
      });
      html += '</tr></thead><tbody>';
      cat.surface_rows.forEach(function (row) {
        html += '<tr><th scope="row">' + row.label + '</th>';
        cat.packs.forEach(function (pack) {
          var cell;
          var bp = null;
          var packEntry = catalogPackById(catalog, pack.id);
          if (packEntry) {
            var sk = row.sqm_max <= 29 ? 's29' : row.sqm_max <= 89 ? 's30_89' : row.sqm_max <= 149 ? 's90_149' : row.sqm_max <= 249 ? 's150_249' : 's250';
            bp = catalogPackPrice(packEntry, sk);
            if (bp == null && packEntry.surfaces && packEntry.surfaces.indexOf(sk) >= 0) {
              bp = catalogPackPrice(packEntry, packEntry.surfaces[0]);
            }
          }
          if (row.force_devis || (packEntry && packEntry.devis)) {
            cell = 'Sur devis';
          } else if (bp != null) {
            cell = hdFormatEuro(bp);
          } else {
            cell = 'Sur devis';
          }
          var link = (row.force_devis || (packEntry && packEntry.devis)) ? devis : (packEntry && packEntry.handle ? '/products/' + packEntry.handle : booking);
          html += '<td><span class="hd-ptable-price">' + cell + '</span><a class="hd-ptable-cta" href="' + link + '">Choisir</a></td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table></div>';
    }

    if (cat.features && cat.features.length && cat.packs && cat.packs.length) {
      html += '<div class="hd-compare-scroll" style="margin-top:32px"><table class="hd-compare-table"><thead><tr><th>Prestation</th>';
      cat.packs.forEach(function (p) { html += '<th>' + p.name + '</th>'; });
      html += '</tr></thead><tbody>';
      cat.features.forEach(function (f) {
        html += '<tr><th scope="row">' + f.label + '</th>';
        cat.packs.forEach(function (p) {
          var v = f.packs && f.packs[p.id];
          if (v === true || v === 'yes') html += '<td><span class="hd-compare-yes">✓</span></td>';
          else if (v === 'devis') html += '<td><span class="hd-compare-devis">Sur devis</span></td>';
          else html += '<td><span class="hd-compare-no">✗</span></td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table></div>';
    }

    html += '</div>';
    return html;
  }

  /* ---------- PACK COMPARE (how-it-works) from JSON ---------- */
  function initPackCompare(root) {
    (root || document).querySelectorAll('[data-hd-pack-compare]').forEach(function (sec) {
      var jsonMount = sec.querySelector('[data-hd-compare-json-mount]');
      if (!jsonMount || sec.dataset.hdCompareBound) return;
      sec.dataset.hdCompareBound = '1';
      var catUrl = sec.getAttribute('data-catalog-url');
      var catId = sec.getAttribute('data-category') || 'vente';
      if (!catUrl) return;
      fetchHdCatalog(catUrl).then(function (catalog) {
        var cat = (catalog && catalog.pricing_categories || []).find(function (c) { return c.id === catId; });
        if (!cat || !cat.features || !cat.packs) return;
        var html = '<div class="hd-compare-scroll"><table class="hd-compare-table"><thead><tr><th>Prestation</th>';
        cat.packs.forEach(function (p) { html += '<th>' + p.name + '</th>'; });
        html += '</tr></thead><tbody>';
        cat.features.forEach(function (f) {
          html += '<tr><th scope="row">' + f.label + '</th>';
          cat.packs.forEach(function (p) {
            var v = f.packs && f.packs[p.id];
            if (v === true) html += '<td><span class="hd-compare-yes">✓</span></td>';
            else if (v === 'devis') html += '<td><span class="hd-compare-devis">Sur devis</span></td>';
            else html += '<td><span class="hd-compare-no">✗</span></td>';
          });
          html += '</tr>';
        });
        html += '</tbody></table></div>';
        jsonMount.innerHTML = html;
        jsonMount.removeAttribute('aria-busy');
      });
    });
  }

  /* ---------- DEVIS WIZARD ---------- */
  function buildAlacartePickStep(catalog) {
    var choices = (catalog && catalog.services ? catalog.services : []).map(function (s) {
      var p = servicePriceStartingFrom(catalog, s.id);
      var hint = p != null ? 'dès ' + hdFormatEuro(p) : 'Sur devis';
      return { id: s.id, label: s.name, sub: hint };
    });
    return {
      id: 'pick',
      question: 'Quels diagnostics souhaitez-vous ?',
      help: 'Sélectionnez un ou plusieurs. Le total sera calculé selon la surface et votre code postal.',
      type: 'multi',
      choices: choices
    };
  }

  var HD_PACK_INCLUDED_IDS = ['dpe', 'erp', 'elec', 'gaz', 'carrez', 'amiante', 'plomb', 'termites'];

  function buildSupplementalStep(catalog) {
    var choices = (catalog && catalog.services ? catalog.services : [])
      .filter(function (s) { return HD_PACK_INCLUDED_IDS.indexOf(s.id) < 0; })
      .map(function (s) {
        var p = servicePriceStartingFrom(catalog, s.id);
        var hint = p != null ? 'dès ' + hdFormatEuro(p) : 'Sur devis';
        return { id: s.id, label: s.name, sub: hint };
      });
    return {
      id: 'extras',
      question: 'Prestations supplémentaires pour la même adresse ?',
      help: 'Cochez ce qui s\'applique à votre situation. Les prestations déjà comprises dans votre pack ne sont pas listées ici.',
      type: 'multi',
      choices: choices
    };
  }

  function getDevisSteps(catalog, answers) {
    var steps = (catalog && catalog.devis_steps ? catalog.devis_steps : []).slice();
    if (answers && answers.goal === 'alacarte') {
      steps = steps.filter(function (s) { return s.id !== 'extras'; });
      var pick = buildAlacartePickStep(catalog);
      var goalIdx = steps.findIndex(function (s) { return s.id === 'goal'; });
      steps.splice(goalIdx >= 0 ? goalIdx + 1 : 0, 0, pick);
    } else if (answers && (answers.goal === 'vente' || answers.goal === 'copro')) {
      var extrasIdx = steps.findIndex(function (s) { return s.id === 'extras'; });
      if (extrasIdx >= 0) steps[extrasIdx] = buildSupplementalStep(catalog);
    }
    return steps;
  }

  function parseDevisUrlParams() {
    try {
      var p = new URLSearchParams(window.location.search);
      var out = {};
      var goal = p.get('goal');
      if (goal) out.goal = goal;
      var pick = p.get('pick');
      if (pick) out.pick = pick.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      return out;
    } catch (e) {
      return {};
    }
  }

  function initDevisWizard(root) {
    (root || document).querySelectorAll('[data-hd-devis-wizard]').forEach(function (sec) {
      if (sec.dataset.hdDevisBound) return;
      sec.dataset.hdDevisBound = '1';
      var mount = sec.querySelector('[data-hd-devis-mount]');
      var catalogUrl = sec.getAttribute('data-catalog-url');
      if (!mount || !catalogUrl) return;

      Promise.all([
        fetchHdCatalog(catalogUrl),
        fetchHdZones(sec.getAttribute('data-zones-url'))
      ]).then(function (results) {
        var catalog = results[0];
        var zones = results[1] || {};
        if (!catalog || !catalog.devis_steps) {
          mount.innerHTML = '<p>Module devis indisponible.</p>';
          return;
        }
        var state = { step: 0, answers: {} };
        var urlPrefill = parseDevisUrlParams();
        if (urlPrefill.goal) state.answers.goal = urlPrefill.goal;
        if (urlPrefill.pick && urlPrefill.pick.length) state.answers.pick = urlPrefill.pick;
        if (urlPrefill.goal) {
          var preSteps = getDevisSteps(catalog, state.answers);
          if (urlPrefill.goal === 'alacarte' && urlPrefill.pick && urlPrefill.pick.length) {
            var pickIdx = preSteps.findIndex(function (s) { return s.id === 'pick'; });
            state.step = pickIdx >= 0 ? pickIdx : 1;
          } else {
            state.step = 1;
          }
        }

        var reservation = sec.getAttribute('data-reservation-url') || '/pages/reservation';
        var uncoveredUrl = sec.getAttribute('data-uncovered-url') || '/pages/uncovered-zone';

        function render() {
          var steps = getDevisSteps(catalog, state.answers);
          var total = steps.length + 1;
          var cur = state.step;
          var dots = '';
          for (var i = 0; i < total; i++) {
            dots += '<span class="' + (i < cur ? 'done' : i === cur ? 'active' : '') + '"></span>';
          }
          var html = '<div class="devis-progress">' + dots + '</div><div class="devis-step">';

          if (cur >= steps.length) {
            html += renderDevisRecap(state, catalog, reservation);
            mount.innerHTML = html;
            var est = computeDevisEstimate(state, catalog);
            bindDevisRecapActions(mount, state, catalog, est);
            var recapPrev = mount.querySelector('[data-hd-devis-prev]');
            if (recapPrev) recapPrev.addEventListener('click', function () {
              state.step = steps.length - 1;
              render();
            });
            return;
          }

          var step = steps[cur];
          html += '<div class="devis-step-meta"><span class="small">Étape ' + (cur + 1) + ' / ' + total + '</span>';
          html += '<span class="small">Temps restant ≈ ' + Math.max(15, (steps.length - cur) * 20) + ' s</span></div>';
          html += '<h2>' + step.question + '</h2>';
          if (step.help) html += '<p class="step-help">' + step.help + '</p>';

          if (step.type === 'number') {
            html += '<input type="number" class="hd-devis-input" data-hd-devis-field="surface" min="1" max="2000" placeholder="' + (step.placeholder || '') + '" value="' + (state.answers.surface || '') + '">';
          } else if (step.type === 'multi') {
            var multiKey = step.id === 'pick' ? 'pick' : 'extras';
            var selected = state.answers[multiKey] || [];
            html += '<div class="hd-devis-checks hd-devis-checks--' + multiKey + '" data-hd-pick-group data-hd-multi-key="' + multiKey + '">';
            (step.choices || []).forEach(function (ch) {
              var on = selected.indexOf(ch.id) >= 0;
              html += '<label class="hd-devis-check"><input type="checkbox" value="' + ch.id + '"' + (on ? ' checked' : '') + '>';
              html += '<span class="hd-devis-check-label"><strong>' + ch.label + '</strong>';
              if (ch.sub) html += '<span class="hd-devis-check-sub">' + ch.sub + '</span>';
              html += '</span></label>';
            });
            html += '</div>';
            if (step.id === 'pick') {
              html += '<p class="hd-devis-field-error" data-hd-devis-error hidden role="alert"></p>';
            }
          } else if (step.id === 'postcode') {
            html += '<input type="text" class="hd-devis-input" data-hd-devis-field="postcode" maxlength="5" pattern="[0-9]{5}" placeholder="' + (step.placeholder || '') + '" value="' + (state.answers.postcode || '') + '">';
            html += '<p class="hd-devis-field-error" data-hd-devis-error hidden role="alert"></p>';
          } else {
            html += '<div class="choice-grid' + ((step.choices || []).length === 3 ? ' choice-grid-3' : '') + '" data-hd-pick-group>';
            (step.choices || []).forEach(function (ch) {
              var on = state.answers[step.id] === ch.id;
              html += '<button type="button" class="choice-card pick-card' + (on ? ' active' : '') + '" data-hd-pick="' + ch.id + '" data-hd-step="' + step.id + '">';
              html += '<div class="ttl">' + ch.label + '</div><div class="sub">' + (ch.sub || '') + '</div></button>';
            });
            html += '</div>';
          }

          html += '<div class="devis-actions">';
          if (cur > 0) html += '<button type="button" class="btn btn-back" data-hd-devis-prev>← Précédent</button>';
          else html += '<a href="' + (sec.getAttribute('data-tarifs-url') || '/pages/tarifs') + '" class="btn btn-back">← Tarifs</a>';
          html += '<button type="button" class="btn btn-dark" data-hd-devis-next>' + (cur === steps.length - 1 ? 'Voir mon estimation' : 'Continuer') + ' →</button>';
          html += '</div></div>';
          mount.innerHTML = html;
          mount.removeAttribute('aria-busy');

          mount.querySelectorAll('[data-hd-pick]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var sid = btn.getAttribute('data-hd-step');
              var val = btn.getAttribute('data-hd-pick');
              mount.querySelectorAll('[data-hd-pick][data-hd-step="' + sid + '"]').forEach(function (b) { b.classList.remove('active'); });
              btn.classList.add('active');
              state.answers[sid] = val;
            });
          });

          var nextBtn = mount.querySelector('[data-hd-devis-next]');
          if (nextBtn) nextBtn.addEventListener('click', function () {
            collectStepFields(mount, state, step);
            var errBox = mount.querySelector('[data-hd-devis-error]');
            if (errBox) { errBox.hidden = true; errBox.textContent = ''; }

            if (step.id === 'pick') {
              if (!state.answers.pick || !state.answers.pick.length) {
                if (errBox) {
                  errBox.textContent = 'Sélectionnez au moins un diagnostic.';
                  errBox.hidden = false;
                }
                return;
              }
            }

            if (step.id === 'postcode') {
              var cp = (state.answers.postcode || '').trim();
              if (!/^\d{5}$/.test(cp)) {
                if (errBox) {
                  errBox.textContent = 'Saisissez un code postal français à 5 chiffres.';
                  errBox.hidden = false;
                }
                return;
              }
              if (shouldBlockPostcode(cp, zones)) {
                if (errBox) {
                  errBox.innerHTML = 'Nous ne couvrons pas encore ce code postal. <a href="' + uncoveredUrl + '">Laissez-nous votre contact →</a>';
                  errBox.hidden = false;
                }
                return;
              }
            }

            state.step++;
            render();
          });
          var prevBtn = mount.querySelector('[data-hd-devis-prev]');
          if (prevBtn) prevBtn.addEventListener('click', function () { state.step--; render(); });
        }

        render();
      }).catch(function () {
        mount.innerHTML = '<p class="hd-pricing-error">Impossible de charger le questionnaire. Rechargez la page ou <a href="/pages/contact">contactez-nous</a>.</p>';
        mount.removeAttribute('aria-busy');
        sec.dataset.hdDevisBound = '';
      });
    });
  }

  function collectStepFields(mount, state, step) {
    if (step.type === 'number') {
      var n = mount.querySelector('[data-hd-devis-field="surface"]');
      state.answers.surface = n ? parseInt(n.value, 10) : null;
    }
    if (step.id === 'postcode') {
      var p = mount.querySelector('[data-hd-devis-field="postcode"]');
      state.answers.postcode = p ? p.value.trim() : '';
    }
    if (step.type === 'multi') {
      var key = step.id === 'pick' ? 'pick' : 'extras';
      state.answers[key] = [];
      mount.querySelectorAll('.hd-devis-check input:checked').forEach(function (inp) {
        state.answers[key].push(inp.value);
      });
    }
  }

  function renderDevisRecap(state, catalog, reservation) {
    var est = computeDevisEstimate(state, catalog);
    var html = '<div class="devis-step-meta"><span class="small">Estimation</span></div>';
    html += '<h2>Votre estimation</h2><p class="step-help">Montant indicatif TTC. Un diagnostiqueur valide sous 24 h.</p>';
    html += '<div class="hd-devis-recap">';
    est.lines.forEach(function (line) {
      html += '<div class="hd-devis-line"><span>' + line.label + '</span><strong>' + line.price + '</strong></div>';
    });
    html += '<div class="hd-devis-total"><span>Total estimé</span><strong>' + est.totalLabel + '</strong></div>';
    if (est.travelNote) html += '<p class="hd-devis-note">' + est.travelNote + '</p>';
    html += '</div><div class="devis-actions devis-actions-recap">';
    html += '<button type="button" class="btn btn-back" data-hd-devis-prev>← Modifier</button>';
    html += '<button type="button" class="btn btn-ghost" data-hd-devis-pdf>Télécharger PDF</button>';
    if (est.canBook) {
      html += '<a href="' + reservation + '" class="btn btn-dark">Réserver en ligne →</a>';
    } else {
      html += '<a href="#devis-pdf" class="btn btn-dark">Recevoir le devis →</a>';
    }
    html += '</div>';
    html += '<textarea id="hd-devis-summary" style="position:absolute;left:-9999px" aria-hidden="true">' + est.summaryText + '</textarea>';
    return html;
  }

  function buildDevisQuotePayload(state, catalog, est) {
    var a = state.answers || {};
    var goalLabels = { vente: 'Vente', location: 'Location', copro: 'Copropriété', mdb: 'Marchands de biens', alacarte: 'À la carte', travaux: 'Travaux / rénovation' };
    var typeLabels = { appart: 'Appartement', maison: 'Maison', local: 'Local / autre' };
    return {
      totalLabel: est.totalLabel,
      travelNote: est.travelNote || '',
      lines: est.lines,
      meta: (function () {
        var rows = [
          ['Objectif', goalLabels[a.goal] || a.goal || '—'],
          ['Type de bien', typeLabels[a.type] || a.type || '—'],
          ['Surface', (a.surface || '—') + ' m²'],
          ['Code postal', a.postcode || '—']
        ];
        if (a.goal === 'alacarte' && a.pick && a.pick.length) {
          var names = (a.pick || []).map(function (id) {
            var svc = catalogServiceById(catalog, id);
            return svc ? svc.name : id;
          });
          rows.splice(1, 0, ['Diagnostics choisis', names.join(', ')]);
        }
        return rows;
      })(),
      summaryText: est.summaryText
    };
  }

  function bindQuotePdfButton(btn, getQuote) {
    if (!btn || btn.dataset.hdQuoteDlBound) return;
    btn.dataset.hdQuoteDlBound = '1';
    btn.addEventListener('click', function () {
      var q = typeof getQuote === 'function' ? getQuote() : getQuote;
      if (!q) return;
      btn.disabled = true;
      downloadDevisPdf(q).catch(function () {
        alert('Impossible de générer le PDF. Réessayez ou contactez-nous.');
      }).finally(function () { btn.disabled = false; });
    });
  }

  function refreshQuotePdfSection(quote) {
    if (!quote) return;
    document.querySelectorAll('[data-hd-quote-pdf]').forEach(function (sec) {
      var dynamic = sec.querySelector('[data-hd-quote-dynamic]');
      if (dynamic) dynamic.hidden = false;
      var gated = sec.querySelector('[data-hd-quote-gated]');
    if (gated) gated.hidden = false;
      sec.querySelectorAll('.hd-quote-hint').forEach(function (hint) {
        if (!dynamic || !dynamic.contains(hint)) hint.hidden = true;
      });
      bindQuotePdfButton(sec.querySelector('[data-hd-quote-download]'), function () { return readDevisQuote(); });
      var form = sec.querySelector('#hd-quote-form');
      var hidden = form && form.querySelector('input[name="contact[body]"]');
      if (hidden && quote.summaryText) hidden.value = quote.summaryText;
    });
  }

  function bindDevisRecapActions(mount, state, catalog, est) {
    var quote = buildDevisQuotePayload(state, catalog, est);
    saveDevisQuote(quote);
    bindRecapPdf(mount);
    refreshQuotePdfSection(quote);
    bindQuotePdfButton(mount.querySelector('[data-hd-devis-pdf]'), quote);
  }

  function computeDevisEstimate(state, catalog) {
    var a = state.answers || {};
    var sqm = a.surface || 85;
    if (!catalog) {
      return {
        lines: [{ label: 'Catalogue indisponible', price: '—' }],
        totalLabel: 'Sur devis',
        travelNote: '',
        canBook: false,
        summaryText: 'Devis HelloDPE — catalogue indisponible'
      };
    }
    if (!a.surface && catalog.devis_rules && a.type && catalog.devis_rules[a.type]) {
      sqm = catalog.devis_rules[a.type].sqm_default || sqm;
    }
    var surfaceKey = sqmToSurfaceKey(sqm);
    var lines = [];
    var subtotal = 0;
    var hasSurDevis = false;
    var rules = catalog.devis_rules || {};
    var goalRule = rules[a.goal] || {};
    var serviceIds = [];
    var freeThreshold = catalog.free_threshold || 139;
    var packCoversServices = false;

    if (a.goal === 'alacarte') {
      serviceIds = (a.pick || []).slice();
      if (!serviceIds.length) {
        return {
          lines: [{ label: 'Sélectionnez vos diagnostics', price: '—' }],
          totalLabel: 'Sur devis',
          travelNote: '',
          canBook: false,
          canPdf: false,
          summaryText: 'Devis HelloDPE — à la carte (aucun diagnostic sélectionné)'
        };
      }
    } else {
      serviceIds = (goalRule.services || []).slice();
      if (a.extras) serviceIds = serviceIds.concat(a.extras);
    }

    if (a.goal === 'vente') {
      var tier = (catalog.booking_packs || []).find(function (p) {
        return p.surfaces && p.surfaces.indexOf(surfaceKey) >= 0 && p.handle && !p.devis;
      });
      if (tier) {
        var tp = catalogPackPrice(tier, surfaceKey);
        if (tp == null) {
          hasSurDevis = true;
          lines.push({ label: tier.title, price: 'Sur devis' });
        } else {
          subtotal += tp;
          packCoversServices = true;
          lines.push({ label: tier.title, price: hdFormatEuro(tp) });
        }
      }
    } else if (goalRule.pack_key) {
      var packEntry = catalogPackById(catalog, goalRule.pack_key);
      if (packEntry) {
        var pp = catalogPackPrice(packEntry, surfaceKey);
        if (pp == null) {
          hasSurDevis = true;
          lines.push({ label: packEntry.title || packEntry.name, price: 'Sur devis' });
        } else {
          subtotal += pp;
          packCoversServices = true;
          lines.push({ label: packEntry.title || packEntry.name, price: hdFormatEuro(pp) });
        }
      }
    }

    if (packCoversServices) {
      serviceIds = (a.extras || []).slice();
    }

    serviceIds.forEach(function (sid) {
      var price = servicePriceFromCatalog(catalog, sid, surfaceKey);
      var svc = catalogServiceById(catalog, sid);
      if (price == null) {
        hasSurDevis = true;
        lines.push({ label: svc ? svc.name : sid, price: 'Sur devis' });
        return;
      }
      subtotal += price;
      lines.push({ label: svc ? svc.name : sid, price: hdFormatEuro(price) });
    });

    if (!lines.length) lines.push({ label: 'Forfait diagnostic', price: 'Sur devis' });

    var total = subtotal;
    var travel = '';
    if (subtotal > 0 && subtotal < freeThreshold) {
      var travelFee = Math.max(0, freeThreshold - subtotal);
      travel = 'Frais de déplacement : complément exact au minimum d’intervention de ' + freeThreshold + ' €.';
      lines.push({ label: 'Frais de déplacement', price: hdFormatEuro(travelFee) });
      total += travelFee;
    } else if (subtotal >= freeThreshold) {
      travel = 'Déplacement offert.';
    }

    var totalLabel = 'Sur devis';
    if (total > 0) {
      totalLabel = hdFormatEuro(total);
      if (hasSurDevis) totalLabel += ' (+ postes sur devis)';
    } else if (hasSurDevis) {
      totalLabel = 'Sur devis';
    }

    var canBook = !hasSurDevis && total > 0;
    var canPdf = lines.length > 0 && (total > 0 || hasSurDevis);
    var summaryText = 'Devis HelloDPE\nObjectif: ' + (a.goal || '') + '\nType: ' + (a.type || '') + '\nSurface: ' + sqm + ' m²\nCP: ' + (a.postcode || '') + '\nTotal: ' + totalLabel + '\n' + lines.map(function (l) { return l.label + ': ' + l.price; }).join('\n');

    return { lines: lines, totalLabel: totalLabel, travelNote: travel, canBook: canBook, canPdf: canPdf, summaryText: summaryText };
  }

  function bindRecapPdf(mount) {
    var form = document.getElementById('hd-quote-form');
    if (!form) return;
    var hidden = form.querySelector('input[name="contact[body]"]');
    var summary = mount.querySelector('#hd-devis-summary');
    if (hidden && summary) hidden.value = summary.value;
  }

  function initQuotePdf(root) {
    (root || document).querySelectorAll('[data-hd-quote-pdf]').forEach(function (sec) {
      if (sec.dataset.hdQuoteBound) return;
      sec.dataset.hdQuoteBound = '1';
      var quote = readDevisQuote();
      if (quote) refreshQuotePdfSection(quote);
    });
  }

  function initTravelFeeProductForms(root) {
    (root || document).querySelectorAll('[data-hd-product][data-hd-travel-fee]').forEach(function (wrap) {
      var productForm = wrap.querySelector('product-form');
      var form = wrap.querySelector('form[data-type="add-to-cart-form"]');
      if (!productForm || !form || form.dataset.hdTravelBound) return;
      form.dataset.hdTravelBound = '1';

      var jsonEl = wrap.querySelector('[data-hd-product-json]');
      var product = null;
      try { product = JSON.parse(jsonEl ? jsonEl.textContent : '{}'); } catch (e) { product = null; }
      if (!product) return;

      var catalogUrl = wrap.getAttribute('data-catalog-url');
      var threshold = parseFloat(wrap.getAttribute('data-free-threshold')) || 139;

      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var submitBtn = productForm.querySelector('[type="submit"]');
        var spinner = productForm.querySelector('.loading__spinner');
        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        var variantInput = form.querySelector('[name="id"]');
        var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        var variant = product.variants.find(function (v) { return v.id === variantId; }) || product.selected_or_first_available_variant;
        var subtotal = variant ? variant.price / 100 : 0;

        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (m && inp.value) props[m[1]] = inp.value;
        });
        Object.assign(props, manualContactProps(null, product.handle));

        var cfgPromise = (catalogUrl ? fetchHdCatalog(catalogUrl) : Promise.resolve(null)).then(function (catalog) {
          return hdCatalogTravelConfig(catalog || {}, { free_threshold: threshold });
        });

        cfgPromise.then(function (cfg) {
          return buildCartItemsWithTravelFee(variantId, subtotal, props, cfg);
        }).then(function (items) {
          return hdCartAddJson(items);
        }).then(function (data) {
          if (data.status && data.description) throw new Error(data.description);
          window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        }).catch(function (err) {
          alert(err.message || 'Impossible d\'ajouter au panier.');
        }).finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
      }, true);
    });
  }

  /* ---------- CHOICE CARDS (legacy page-quote) ---------- */
  function initPickCards(root) {
    (root || document).querySelectorAll('[data-hd-pick-group]').forEach(function (group) {
      if (group.dataset.hdPickBound) return;
      group.dataset.hdPickBound = '1';
      group.querySelectorAll('.pick-card, .choice-card').forEach(function (card) {
        card.addEventListener('click', function () {
          group.querySelectorAll('.pick-card, .choice-card').forEach(function (c) { c.classList.remove('active'); });
          card.classList.add('active');
        });
      });
    });
  }

  /* ---------- PRODUCT PAGE (variants, price, gallery) ---------- */
  function hdFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return Math.round(cents / 100) + ' €';
  }

  var _hdDurationMapCache = null;

  function fetchHdDurationMap(url) {
    if (_hdDurationMapCache) return Promise.resolve(_hdDurationMapCache);
    if (!url) return Promise.resolve(null);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        _hdDurationMapCache = d;
        return d;
      })
      .catch(function () { return null; });
  }

  function hdNormVariantLabel(s) {
    return (s || '').toLowerCase().replace(/[²㎡]/g, '2').replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();
  }

  function hdResolveProductPageMeta(catalog, handle) {
    if (!catalog || !handle) return null;
    var pack = (catalog.booking_packs || []).find(function (p) { return p.handle === handle; });
    if (pack) {
      var catId = (catalog.product_page && catalog.product_page.pack_categories && catalog.product_page.pack_categories[pack.key]) || 'vente';
      return { type: 'pack', pack_key: pack.key, pack: pack, category_id: catId };
    }
    var svc = (catalog.services || []).find(function (s) { return s.handle === handle; });
    if (svc) return { type: 'service', service: svc, service_id: svc.id };
    return null;
  }

  function hdProductDurationEntry(durationMap, catalog, handle, variantLabel) {
    var aliases = (catalog && catalog.product_page && catalog.product_page.duration_handles) || {};
    var dmHandle = aliases[handle] || handle;
    var prod = (durationMap && durationMap.products || []).find(function (p) { return p.handle === dmHandle; });
    if (!prod || !prod.variants || !prod.variants.length) return null;
    var norm = hdNormVariantLabel(variantLabel);
    var match = prod.variants.find(function (v) { return hdNormVariantLabel(v.label) === norm; });
    if (!match) {
      match = prod.variants.find(function (v) {
        var vl = hdNormVariantLabel(v.label);
        return vl.indexOf(norm) >= 0 || norm.indexOf(vl) >= 0;
      });
    }
    if (!match && prod.variants.length === 1) match = prod.variants[0];
    return match || null;
  }

  function hdUpdateProductTagline(wrap, catalog, meta) {
    var el = wrap.querySelector('[data-hd-product-tagline]');
    if (!el || !meta || meta.type !== 'pack') {
      if (el) el.hidden = true;
      return;
    }
    var cat = (catalog.pricing_categories || []).find(function (c) { return c.id === meta.category_id; });
    var packMeta = cat && (cat.packs || []).find(function (p) { return p.id === meta.pack_key; });
    var text = packMeta ? packMeta.tagline : '';
    if (text) {
      el.textContent = text;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function hdRenderProductIncludes(wrap, catalog, meta) {
    var block = wrap.querySelector('[data-hd-product-includes]');
    if (!block) return;
    if (!meta) {
      block.hidden = true;
      return;
    }
    var titleEl = block.querySelector('[data-hd-product-includes-title]');
    var listEl = block.querySelector('[data-hd-product-includes-list]');
    var footEl = block.querySelector('[data-hd-product-includes-foot]');
    if (!listEl) return;

    if (meta.type === 'pack') {
      var cat = (catalog.pricing_categories || []).find(function (c) { return c.id === meta.category_id; });
      var packMeta = cat && (cat.packs || []).find(function (p) { return p.id === meta.pack_key; });
      if (titleEl) {
        titleEl.textContent = packMeta ? ('Ce pack comprend — ' + packMeta.name) : (titleEl.textContent || 'Ce pack comprend');
      }
      var packServices = ['DPE', 'Élec', 'Gaz', 'ERP', 'Amiante*', 'Plomb*', 'Termites*', 'Loi Carrez*'];
      listEl.innerHTML = packServices.map(function (label) {
        return '<li class="hd-product-inc-yes"><span aria-hidden="true">✓</span> ' + label + '</li>';
      }).join('');
      if (footEl) {
        if (meta.pack.devis) {
          footEl.textContent = 'Cette prestation fait l\'objet d\'un devis personnalisé.';
          footEl.hidden = false;
        } else {
          footEl.hidden = true;
          footEl.textContent = '';
        }
      }
      block.hidden = false;
      block.removeAttribute('aria-busy');
      return;
    }

    if (meta.type === 'service') {
      /* Les fiches diagnostics suivent la maquette éditoriale sans bloc
         d'inclusion intermédiaire. Ce bloc reste réservé aux packs. */
      block.hidden = true;
      block.removeAttribute('aria-busy');
    }
  }

  function hdFormatDurationMinutes(mins) {
    if (!mins || mins <= 0) return '';
    if (mins < 60) return mins + ' min';
    var h = Math.floor(mins / 60);
    var r = mins % 60;
    return r ? (h + ' h ' + r + ' min') : (h + ' h');
  }

  function hdUpdateProductDuration(wrap, durationMap, catalog, product, variant) {
    var el = wrap.querySelector('[data-hd-product-duration]');
    if (!el || !product) return;
    var label = variant && variant.options ? variant.options.join(' / ') : '';
    var entry = hdProductDurationEntry(durationMap, catalog, product.handle, label);
    if (!entry || entry.duration_minutes == null) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    var dur = hdFormatDurationMinutes(entry.duration_minutes);
    var tier = entry.calendly_tier ? ' (' + entry.calendly_tier + ')' : '';
    el.innerHTML = '<span class="hd-product-duration-icon" aria-hidden="true">⏱</span> Durée estimée sur site : <strong>' + dur + '</strong><span class="hd-product-duration-tier">' + tier + '</span>';
    el.hidden = false;
  }

  function initProductPage(root) {
    (root || document).querySelectorAll('[data-hd-product]').forEach(function (wrap) {
      if (wrap.dataset.hdProductBound) return;
      wrap.dataset.hdProductBound = '1';
      initTravelFeeProductForms(wrap);

      var jsonEl = wrap.querySelector('[data-hd-product-json]');
      var product = null;
      try { product = JSON.parse(jsonEl ? jsonEl.textContent : '{}'); } catch (e) { product = null; }

      var mainImg = wrap.querySelector('[data-hd-product-main-img]');
      wrap.querySelectorAll('[data-hd-product-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          wrap.querySelectorAll('[data-hd-product-thumb]').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          if (mainImg && thumb.getAttribute('data-src')) {
            mainImg.src = thumb.getAttribute('data-src');
          }
        });
      });

      if (!product || !product.variants) return;

      var catalogUrl = wrap.getAttribute('data-catalog-url');
      var durationUrl = wrap.getAttribute('data-duration-map-url');
      var pageMeta = null;
      var durationMap = null;

      Promise.all([
        catalogUrl ? fetchHdCatalog(catalogUrl) : Promise.resolve(null),
        durationUrl ? fetchHdDurationMap(durationUrl) : Promise.resolve(null)
      ]).then(function (res) {
        var catalog = res[0];
        durationMap = res[1];
        pageMeta = hdResolveProductPageMeta(catalog, product.handle);
        hdUpdateProductTagline(wrap, catalog, pageMeta);
        hdRenderProductIncludes(wrap, catalog, pageMeta);
        var variant = findVariant(selectedOptions());
        if (variant) hdUpdateProductDuration(wrap, durationMap, catalog, product, variant);
      });

      var form = wrap.querySelector('form[data-type="add-to-cart-form"]');
      var variantInput = form ? form.querySelector('.product-variant-id') : null;
      var priceEl = wrap.querySelector('[data-hd-product-price]');
      var isCoproProduct = String(wrap.getAttribute('data-product-handle') || '').toLowerCase().indexOf('copro') >= 0;
      var submitBtn = wrap.querySelector('.product-form__submit');
      var tunnelBtn = wrap.querySelector('[data-hd-product-tunnel-button]');

      function surfaceNumberFromLabel(label) {
        var clean = String(label || '').replace(/\u00a0/g, ' ').toLowerCase();
        var numbers = clean.match(/\d+/g);
        if (!numbers || !numbers.length || clean.indexOf('default title') >= 0) return '';
        var values = numbers.map(function (n) { return Number(n); }).filter(function (n) { return Number.isFinite(n); });
        if (!values.length) return '';
        if (clean.indexOf('≥') >= 0 || clean.indexOf('plus de') >= 0) return String(values[0]);
        if (clean.indexOf('≤') >= 0 || clean.indexOf("jusqu'à") >= 0 || clean.indexOf('jusqu’à') >= 0) return String(values[values.length - 1]);
        if (values.length >= 2) return String(Math.round((values[0] + values[1]) / 2));
        return String(values[0]);
      }

      function lotsValueFromLabel(label) {
        var clean = String(label || '').replace(/\u00a0/g, ' ').toLowerCase();
        var numbers = clean.match(/\d+/g) || [];
        if (clean.indexOf('plus de') >= 0 || clean.indexOf('+ de') >= 0 || clean.indexOf('> 100') >= 0 || clean.indexOf('≥ 101') >= 0) return '100plus';
        if (!numbers.length || clean.indexOf('default title') >= 0) return '';
        var maximum = Number(numbers[numbers.length - 1]);
        if (maximum <= 10) return '10';
        if (maximum <= 20) return '20';
        if (maximum <= 50) return '50';
        if (maximum <= 100) return '100';
        return '100plus';
      }

      function syncTunnelButton(variant) {
        if (!tunnelBtn) return;
        var base = tunnelBtn.getAttribute('data-base-url') || tunnelBtn.getAttribute('href') || '/pages/prendre-rdv';
        try {
          var url = new URL(base, window.location.origin);
          var firstOption = variant && variant.options ? variant.options[0] : '';
          if (isCoproProduct) {
            var lots = lotsValueFromLabel(firstOption);
            url.searchParams.delete('surface');
            if (lots) url.searchParams.set('lots', lots);
          } else {
            var surface = surfaceNumberFromLabel(firstOption);
            url.searchParams.delete('lots');
            if (surface) url.searchParams.set('surface', surface);
          }
          url.searchParams.set('step', '1');
          url.searchParams.set('start', '1');
          tunnelBtn.href = url.pathname + url.search + url.hash;
        } catch (e) {
          tunnelBtn.href = base;
        }
      }

      function selectedOptions() {
        var opts = [];
        wrap.querySelectorAll('[data-hd-product-select]').forEach(function (sel) {
          opts.push(sel.value);
        });
        return opts;
      }

      function findVariant(opts) {
        return product.variants.find(function (v) {
          if (!v.options) return false;
          return v.options.every(function (opt, i) { return opt === opts[i]; });
        });
      }

      function syncVariant() {
        var variant = findVariant(selectedOptions());
        if (!variant) return;
        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.disabled = !variant.available;
        }
        if (priceEl) {
          if (variant.price <= 0) {
            priceEl.innerHTML = '<span class="hd-product-price-amount hd-product-price-devis">Sur devis</span>';
          } else {
            var priceDetail = isCoproProduct
              ? hdFormatMoney(Math.round(variant.price / 1.2)) + ' HT · TVA 20 %'
              : 'à partir de';
            priceEl.innerHTML = '<span class="hd-product-price-amount">' + hdFormatMoney(variant.price) + '</span><span class="hd-product-price-ttc">TTC<small>' + priceDetail + '</small></span>';
          }
        }
        wrap.querySelectorAll('[data-hd-pack-surface]').forEach(function (el) {
          var surface = variant.options && variant.options.length ? variant.options[0] : '';
          if (surface && surface !== 'Default Title') el.textContent = surface;
        });
        if (submitBtn) {
          var surDevis = variant.price <= 0;
          submitBtn.disabled = !variant.available || surDevis;
          var label = submitBtn.querySelector('span');
          if (label) {
            if (surDevis) label.textContent = 'Sur devis — contactez-nous';
            else label.textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
          }
        }
        if (durationMap) {
          var catalog = _hdCatalogCache;
          hdUpdateProductDuration(wrap, durationMap, catalog, product, variant);
        }
        syncTunnelButton(variant);
      }

      syncVariant();

      wrap.querySelectorAll('[data-hd-product-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = pill.getAttribute('data-option-index');
          var val = pill.getAttribute('data-value');
          wrap.querySelectorAll('[data-hd-product-pill][data-option-index="' + idx + '"]').forEach(function (p) {
            p.classList.toggle('active', p === pill);
          });
          var sel = wrap.querySelector('#Option-' + wrap.getAttribute('data-section-id') + '-' + idx);
          if (sel) {
            sel.value = val;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          syncVariant();
        });
      });

      wrap.querySelectorAll('[data-hd-product-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var idx = sel.id.split('-').pop();
          wrap.querySelectorAll('[data-hd-product-pill][data-option-index="' + idx + '"]').forEach(function (p) {
            p.classList.toggle('active', p.getAttribute('data-value') === sel.value);
          });
          syncVariant();
        });
      });
    });
  }

  /* ---------- PRICING BUILDER (client tarifs page) ---------- */
  var HD_PB_PACK_KEYS = {
    vente: ['essentiel', 'confort', 'premium', 'prestige', 'platinium'],
    location: ['essentiel', 'confort', 'premium', 'prestige', 'platinium'],
    copropriete: [],
    marchands: ['mdb'],
    audit: ['audit']
  };
  var HD_PB_PACK_SURFACE = {
    essentiel: 's29',
    confort: 's30_89',
    premium: 's90_149',
    prestige: 's150_249',
    platinium: 's250'
  };
  var HD_PB_SERVICE_IDS = {
    vente: ['dpe', 'erp', 'elec', 'gaz', 'carrez', 'amiante', 'plomb', 'termites', 'parasitaire', 'bruit', 'dpe-projete'],
    location: ['dpe', 'erp', 'boutin', 'elec', 'gaz', 'bruit']
  };
  var _hdPbSetCategory = null;

  function hdScrollToAnchor(hash) {
    if (!hash || hash.charAt(0) !== '#') return;
    var el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hdPbResolveCategory(sec) {
    var params = new URLSearchParams(window.location.search);
    var urlCat = params.get('cat');
    if (urlCat) return urlCat;
    if (sec) return sec.getAttribute('data-default-category') || 'vente';
    var builder = document.querySelector('[data-hd-pricing-builder]');
    return builder ? (builder.getAttribute('data-default-category') || 'vente') : 'vente';
  }

  function hdPbActivatePill(cat) {
    if (!cat) return;
    document.querySelectorAll('[data-hd-pricing-pill]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-hd-pricing-pill') === cat);
    });
  }

  function hdPbScrollForCategory(cat) {
    var map = {
      diagnostics: '#diagnostics',
      estimations: '#diagnostics',
      devis: '#devis',
      vente: '#packs',
      location: '#packs',
      copropriete: '#packs',
      marchands: '#packs',
      audit: '#packs'
    };
    if (map[cat] && !window.location.hash) hdScrollToAnchor(map[cat]);
  }

  function initPricingPills(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-hd-pricing-pill]').forEach(function (pill) {
      if (pill.dataset.hdPillBound) return;
      pill.dataset.hdPillBound = '1';
      pill.addEventListener('click', function (e) {
        var cat = pill.getAttribute('data-hd-pricing-pill');
        var target = pill.getAttribute('href');
        if (!cat && !(target && target.charAt(0) === '#')) return;
        e.preventDefault();
        if (cat) {
          document.dispatchEvent(new CustomEvent('hd-pricing-category', { detail: { category: cat } }));
          document.querySelectorAll('[data-hd-pricing-pill]').forEach(function (p) {
            p.classList.toggle('is-active', p === pill);
          });
        }
        if (target && target.charAt(0) === '#') hdScrollToAnchor(target);
      });
    });

    scope.querySelectorAll('.hd-pills .hd-pill[href^="#"]:not([data-hd-pricing-pill])').forEach(function (pill) {
      if (pill.dataset.hdPillBound) return;
      pill.dataset.hdPillBound = '1';
      pill.addEventListener('click', function (e) {
        var target = pill.getAttribute('href');
        if (!target || target.length < 2) return;
        e.preventDefault();
        hdScrollToAnchor(target);
      });
    });

    if (scope === document && !document.documentElement.dataset.hdPbPillInit) {
      document.documentElement.dataset.hdPbPillInit = '1';
      var builder = document.querySelector('[data-hd-pricing-builder]');
      hdPbActivatePill(hdPbResolveCategory(builder));
    }
  }

  function formatPbPrice(n) {
    if (n == null || isNaN(n)) return 'Sur devis';
    return Math.round(n) + ' €';
  }

  function initPricingBuilder(root) {
    (root || document).querySelectorAll('[data-hd-pricing-builder]').forEach(function (sec) {
      if (sec.dataset.hdPbBound) return;
      sec.dataset.hdPbBound = '1';

      var catalogUrl = sec.getAttribute('data-catalog-url');
      var minAlacarte = parseFloat(sec.getAttribute('data-min-alacarte')) || 99;
      var travelCfg = hdTravelConfig({
        free_threshold: parseFloat(sec.getAttribute('data-free-threshold')) || 139,
        travel_fee: parseFloat(sec.getAttribute('data-travel-fee')) || 59,
        travel_fee_product_handle: 'frais-de-deplacement'
      });

      var initialCategory = hdPbResolveCategory(sec);
      var state = { category: initialCategory, packKey: null, serviceIds: [], surfaceKey: 's29' };
      var packsMount = sec.querySelector('[data-hd-pb-packs-mount]');
      var servicesMount = sec.querySelector('[data-hd-pb-services-mount]');
      var form = sec.querySelector('[data-hd-pb-form]');
      var surfaceSel = sec.querySelector('[data-hd-pb-surface]');
      var errEl = sec.querySelector('[data-hd-pb-error]');
      if (!packsMount || !catalogUrl) return;

      function getCatalogPack(key, catalog) {
        var bp = (catalog.booking_packs || []).find(function (p) { return p.key === key; });
        if (bp) return bp;
        return (catalog.copro_products || []).find(function (c) { return c.key === key; }) || null;
      }

      function pbPackRequiresDevisPage(packKey, catalog) {
        if (!packKey) return false;
        var entry = getCatalogPack(packKey, catalog);
        if (!entry) return false;
        if (entry.handle && isManualContactHandle(entry.handle)) return false;
        return !!(entry.devis || entry.funnel === 'devis');
      }

      function pbCanDownloadPdf(q) {
        return !!(q.lines && q.lines.length);
      }

      function pbCanReserve(q, catalog) {
        if (!q.lines || !q.lines.length) return false;
        if (state.packKey) {
          if (pbPackRequiresDevisPage(state.packKey, catalog)) return true;
          var entry = getCatalogPack(state.packKey, catalog);
          if (entry && entry.handle && isManualContactHandle(entry.handle)) return true;
          return q.subtotal > 0;
        }
        if (!state.serviceIds.length) return false;
        if (q.subtotal >= minAlacarte) return true;
        return state.serviceIds.every(function (sid) {
          return servicePriceFromCatalog(catalog, sid, state.surfaceKey) == null;
        });
      }

      function pbFormProps(fd, surfLabel) {
        var props = {};
        if (fd.postcode) props['Code postal'] = fd.postcode;
        if (fd.first_name) props['Prénom'] = fd.first_name;
        if (fd.last_name) props['Nom'] = fd.last_name;
        if (fd.email) props['Email'] = fd.email;
        if (fd.phone) props['Téléphone'] = fd.phone;
        if (fd.address) props['Adresse'] = fd.address;
        if (fd.city) props['Ville'] = fd.city;
        if (fd.company) props['Entreprise'] = fd.company;
        if (fd.reference) props['Référence'] = fd.reference;
        if (surfLabel) props['Surface'] = surfLabel;
        return props;
      }

      function showPbError(msg) {
        if (!errEl) return;
        errEl.textContent = msg;
        errEl.hidden = !msg;
      }

      function surfaceTierLabel(catalog, surfaceKey) {
        var tiers = (catalog && catalog.surface_tiers) || [];
        var tier = tiers.find(function (t) { return t.key === surfaceKey; });
        return tier ? tier.label : '';
      }

      function renderPacks(catalog) {
        var keys = HD_PB_PACK_KEYS[state.category] || [];
        if (state.category === 'diagnostics' || state.category === 'estimations' || state.category === 'devis') {
          packsMount.innerHTML = '<p class="hd-pb-muted">Utilisez la section diagnostics ci-dessous ou consultez l\'aperçu du devis.</p>';
          packsMount.removeAttribute('aria-busy');
          return;
        }
        if (state.category === 'copropriete' || state.category === 'marchands') {
          var coproHtml = '';
          var items = state.category === 'marchands'
            ? [(catalog.booking_packs || []).find(function (p) { return p.key === 'mdb'; })].filter(Boolean)
            : (catalog.copro_products || []);
          items.forEach(function (c) {
            var key = c.key || 'mdb';
            var active = state.packKey === key ? ' active' : '';
            coproHtml += '<label class="hd-pb-pack-card' + active + '"><input type="radio" name="hd_pb_pack" value="' + key + '" data-handle="' + (c.handle || '') + '" data-devis="1"' + (state.packKey === key ? ' checked' : '') + '><span class="hd-pb-pack-name">' + (c.title || c.name || 'Pack') + '</span><span class="hd-pb-pack-price">Sur devis</span><span class="hd-pb-pack-note">Devis sous 24 h</span></label>';
          });
          packsMount.innerHTML = coproHtml || '<p class="hd-pb-muted">Contactez-nous pour un devis copropriété.</p>';
          packsMount.removeAttribute('aria-busy');
          bindPackRadios();
          return;
        }
        var html = '';
        keys.forEach(function (key) {
          var entry = getCatalogPack(key, catalog);
          if (!entry) return;
          var packSurface = HD_PB_PACK_SURFACE[key] || (entry.surfaces && entry.surfaces[0]) || state.surfaceKey;
          var price = catalogPackPrice(entry, packSurface) || (entry.price != null && entry.price > 0 ? entry.price : null);
          var priceLabel = price != null ? formatPbPrice(price) : 'Sur devis';
          var active = state.packKey === key ? ' active' : '';
          var compatible = entry.variant_axis || entry.devis || packSurface === state.surfaceKey
            || !entry.surfaces || entry.surfaces.indexOf(state.surfaceKey) >= 0;
          var note = surfaceTierLabel(catalog, packSurface);
          html += '<label class="hd-pb-pack-card' + active + (compatible ? '' : ' is-disabled') + '"><input type="radio" name="hd_pb_pack" value="' + key + '" data-handle="' + (entry.handle || '') + '"' + (entry.devis ? ' data-devis="1"' : '') + (state.packKey === key ? ' checked' : '') + (compatible ? '' : ' disabled') + '><span class="hd-pb-pack-name">' + entry.title + '</span><span class="hd-pb-pack-price">' + priceLabel + '</span>' + (note ? '<span class="hd-pb-pack-note">' + note + '</span>' : '') + '</label>';
        });
        packsMount.innerHTML = html || '<p class="hd-pb-muted">Aucun pack disponible.</p>';
        packsMount.removeAttribute('aria-busy');
        bindPackRadios();
      }

      function bindPackRadios() {
        packsMount.querySelectorAll('input[name="hd_pb_pack"]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            state.packKey = radio.checked ? radio.value : null;
            packsMount.querySelectorAll('.hd-pb-pack-card').forEach(function (c) {
              c.classList.toggle('active', c.contains(radio) && radio.checked);
            });
            updateEstimate(catalog);
          });
        });
      }

      function servicesForCategory(cat) {
        var all = (cat && cat.services) ? cat.services.slice() : [];
        if (state.category === 'estimations') {
          return all.filter(function (s) { return s.id === 'estim-venale' || s.id === 'estim-locative'; });
        }
        if (state.category === 'audit') {
          return all.filter(function (s) { return s.id === 'audit'; });
        }
        if (state.category === 'diagnostics') {
          return all.filter(function (s) {
            return s.id !== 'estim-venale' && s.id !== 'estim-locative' && s.id !== 'audit';
          });
        }
        if (state.category === 'copropriete' || state.category === 'marchands' || state.category === 'devis') {
          return [];
        }
        var allowed = HD_PB_SERVICE_IDS[state.category];
        if (allowed && allowed.length) {
          return all.filter(function (s) { return allowed.indexOf(s.id) >= 0; });
        }
        return all.filter(function (s) {
          return s.id !== 'estim-venale' && s.id !== 'estim-locative';
        });
      }

      function renderServices(catalog) {
        if (!servicesMount) return;
        var list = servicesForCategory(catalog);
        var html = '<div class="hd-pb-svc-grid">';
        list.forEach(function (svc) {
          var price = servicePriceFromCatalog(catalog, svc.id, state.surfaceKey);
          var priceLabel = price != null ? formatPbPrice(price) : 'Sur devis';
          var checked = state.serviceIds.indexOf(svc.id) >= 0 ? ' checked' : '';
          html += '<label class="hd-pb-svc-card"><input type="checkbox" name="hd_pb_svc" value="' + svc.id + '" data-handle="' + (svc.handle || '') + '"' + checked + '><span class="hd-pb-svc-name">' + svc.name + '</span><span class="hd-pb-svc-price">' + priceLabel + '</span></label>';
        });
        html += '</div>';
        servicesMount.innerHTML = html;
        servicesMount.removeAttribute('aria-busy');
        servicesMount.querySelectorAll('input[name="hd_pb_svc"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var svcHandle = cb.getAttribute('data-handle');
        if (cb.checked) {
          if (state.serviceIds.indexOf(cb.value) < 0) state.serviceIds.push(cb.value);
          if (svcHandle) {
            fetchProductDurations(svcHandle).then(function (durMap) {
              state.serviceDurations = state.serviceDurations || {};
              var vals = Object.keys(durMap).map(function (k) { return durMap[k]; }).filter(function (n) { return n > 0; });
              state.serviceDurations[cb.value] = vals.length ? Math.min.apply(null, vals) : 0;
              updateEstimate(catalog);
            });
          }
        } else {
          state.serviceIds = state.serviceIds.filter(function (id) { return id !== cb.value; });
          if (state.serviceDurations) delete state.serviceDurations[cb.value];
        }
        updateEstimate(catalog);
      });
    });
      }

      function readForm() {
        if (!form) return {};
        var fd = {};
        form.querySelectorAll('input, select').forEach(function (el) {
          if (el.name) fd[el.name] = el.value.trim();
        });
        return fd;
      }

      function buildQuoteLines(catalog) {
        var lines = [];
        var subtotal = 0;
        if (state.packKey) {
          var packEntry = getCatalogPack(state.packKey, catalog);
          if (packEntry) {
            var pp = catalogPackPrice(packEntry, state.surfaceKey);
            if (pp != null) {
              lines.push({ label: packEntry.title, price: formatPbPrice(pp), amount: pp });
              subtotal += pp;
            } else {
              lines.push({ label: packEntry.title, price: 'Sur devis', amount: 0 });
            }
          }
        }
        state.serviceIds.forEach(function (sid) {
          var svc = catalogServiceById(catalog, sid);
          if (!svc) return;
          var sp = servicePriceFromCatalog(catalog, sid, state.surfaceKey);
          if (sp != null) {
            lines.push({ label: svc.name, price: formatPbPrice(sp), amount: sp });
            subtotal += sp;
          } else {
            lines.push({ label: svc.name, price: 'Sur devis', amount: 0 });
          }
        });
        if (subtotal > 0 && needsTravelFee(subtotal, travelCfg)) {
          var travelAmount = Math.max(0, travelCfg.free_threshold - subtotal);
          lines.push({ label: 'Frais de déplacement', price: formatPbPrice(travelAmount), amount: travelAmount });
          subtotal += travelAmount;
        } else if (subtotal >= travelCfg.free_threshold) {
          lines.push({ label: 'Frais de déplacement', price: 'Offert', amount: 0 });
        }
        return { lines: lines, subtotal: subtotal };
      }

      function updateEstimate(catalog) {
        var fd = readForm();
        var q = buildQuoteLines(catalog);
        var linesEl = sec.querySelector('[data-hd-pb-lines]');
        var totalEl = sec.querySelector('[data-hd-pb-total]');
        var dateEl = sec.querySelector('[data-hd-pb-date]');
        var refEl = sec.querySelector('[data-hd-pb-ref]');
        var custEl = sec.querySelector('[data-hd-pb-customer]');
        var pdfBtn = sec.querySelector('[data-hd-pb-pdf]');
        var resBtn = sec.querySelector('[data-hd-pb-reserve]');

        if (dateEl) dateEl.textContent = new Date().toLocaleDateString('fr-FR');
        if (refEl) refEl.textContent = fd.reference || 'HD-' + Date.now().toString().slice(-6);
        if (custEl) {
          var name = [fd.first_name, fd.last_name].filter(Boolean).join(' ');
          custEl.textContent = name || '—';
        }
        if (linesEl) {
          if (!q.lines.length) {
            linesEl.innerHTML = '<tr><td colspan="2" class="hd-pb-empty">Sélectionnez un pack ou des diagnostics.</td></tr>';
          } else {
            linesEl.innerHTML = q.lines.map(function (l) {
              return '<tr><td>' + l.label + '</td><td>' + l.price + '</td></tr>';
            }).join('');
          }
        }
        if (totalEl) {
          totalEl.textContent = q.subtotal > 0 ? formatPbPrice(q.subtotal) + ' TTC' : '—';
        }
        if (pdfBtn) pdfBtn.disabled = !pbCanDownloadPdf(q);
        if (resBtn) resBtn.disabled = !pbCanReserve(q, catalog);
        if (errEl) {
          if (!state.packKey && state.serviceIds.length && q.subtotal > 0 && q.subtotal < minAlacarte) {
            errEl.textContent = 'Minimum ' + minAlacarte + ' € pour réserver à la carte (sans pack). Le PDF reste disponible.';
            errEl.hidden = false;
          } else if (!resBtn || !resBtn.disabled) {
            errEl.hidden = true;
          }
        }
        sec._hdPbQuote = {
          lines: q.lines.map(function (l) { return { label: l.label, price: l.price }; }),
          totalLabel: q.subtotal > 0 ? formatPbPrice(q.subtotal) + ' TTC' : '—',
          meta: [
            ['Client', [fd.first_name, fd.last_name].filter(Boolean).join(' ') || '—'],
            ['Email', fd.email || '—'],
            ['Adresse', [fd.address, fd.postcode, fd.city].filter(Boolean).join(', ') || '—'],
            ['Surface', surfaceSel ? surfaceSel.options[surfaceSel.selectedIndex].text : '—']
          ],
          travelNote: q.subtotal >= travelCfg.free_threshold ? 'Déplacement offert dès ' + travelCfg.free_threshold + ' €.' : ''
        };

        var totalMins = 0;
        if (state.serviceDurations) {
          Object.keys(state.serviceDurations).forEach(function (k) { totalMins += state.serviceDurations[k] || 0; });
        }
        var calBox = sec.querySelector('[data-hd-pb-calendly]');
        if (calBox) {
          if (fd.postcode && /^\d{5}$/.test(fd.postcode) && totalMins > 0) {
            resolveCalendlyLink(fd.postcode, totalMins).then(function (link) {
              if (link) {
                calBox.innerHTML = '<a href="' + link + '" target="_blank" class="btn btn-dark">Choisir mon créneau (' + Math.round(totalMins) + ' min) →</a>';
                calBox.hidden = false;
              } else {
                calBox.hidden = true;
              }
            });
          } else {
            calBox.hidden = true;
          }
        }
      }

      var catalog = null;

      function setCategory(cat) {
        state.category = cat || 'vente';
        state.packKey = null;
        state.serviceIds = [];
        if (!catalog) return;
        renderPacks(catalog);
        renderServices(catalog);
        updateEstimate(catalog);
      }

      _hdPbSetCategory = setCategory;
      if (!document.documentElement.dataset.hdPbCatListen) {
        document.documentElement.dataset.hdPbCatListen = '1';
        document.addEventListener('hd-pricing-category', function (e) {
          if (_hdPbSetCategory && e.detail && e.detail.category) {
            _hdPbSetCategory(e.detail.category);
          }
        });
      }

      fetchHdCatalog(catalogUrl).then(function (cat) {
        catalog = cat;
        if (catalog) {
          travelCfg = hdCatalogTravelConfig(catalog, {
            free_threshold: parseFloat(sec.getAttribute('data-free-threshold')) || undefined,
            travel_fee: parseFloat(sec.getAttribute('data-travel-fee')) || undefined
          });
          if (catalog.min_alacarte) minAlacarte = catalog.min_alacarte;
        }
        if (!catalog) {
          packsMount.innerHTML = '<p class="hd-pb-error">Impossible de charger le catalogue tarifs.</p>';
          if (servicesMount) {
            servicesMount.innerHTML = '<p class="hd-pb-error">Impossible de charger le catalogue tarifs.</p>';
            servicesMount.removeAttribute('aria-busy');
          }
          return;
        }
        sec._hdPbCatalog = catalog;
        if (surfaceSel) {
          surfaceSel.addEventListener('change', function () {
            state.surfaceKey = surfaceSel.value;
            if (state.packKey) {
              var entry = getCatalogPack(state.packKey, catalog);
              if (entry && entry.surfaces && entry.surfaces.indexOf(state.surfaceKey) < 0 && !entry.variant_axis) {
                state.packKey = null;
              }
            }
            renderPacks(catalog);
            renderServices(catalog);
            updateEstimate(catalog);
          });
        }
        if (form) {
          form.addEventListener('input', function () { updateEstimate(catalog); });
          form.addEventListener('change', function () { updateEstimate(catalog); });
        }
        if (surfaceSel) state.surfaceKey = surfaceSel.value;
        setCategory(initialCategory);
        hdPbActivatePill(initialCategory);
        hdPbScrollForCategory(initialCategory);

        var pdfBtn = sec.querySelector('[data-hd-pb-pdf]');
        if (pdfBtn) {
          pdfBtn.addEventListener('click', function () {
            if (!sec._hdPbQuote || !pbCanDownloadPdf({ lines: sec._hdPbQuote.lines })) return;
            pdfBtn.disabled = true;
            saveDevisQuote(sec._hdPbQuote);
            downloadDevisPdf(sec._hdPbQuote).catch(function () {
              showPbError('Impossible de générer le PDF. Réessayez ou contactez-nous.');
            }).finally(function () {
              pdfBtn.disabled = !pbCanDownloadPdf(buildQuoteLines(catalog));
            });
          });
        }
  
        var resBtn = sec.querySelector('[data-hd-pb-reserve]');
        if (resBtn) {
          resBtn.addEventListener('click', function () {
            var fd = readForm();
            var q = buildQuoteLines(catalog);
            if (!pbCanReserve(q, catalog)) return;
            if (!fd.postcode || !/^\d{5}$/.test(fd.postcode)) {
              showPbError('Indiquez un code postal à 5 chiffres pour réserver.');
              return;
            }
            var surfLabel = surfaceSel ? surfaceSel.options[surfaceSel.selectedIndex].text : '';
            var bookableServices = state.serviceIds.filter(function (sid) {
              return servicePriceFromCatalog(catalog, sid, state.surfaceKey) != null;
            });
            if (state.packKey && pbPackRequiresDevisPage(state.packKey, catalog) && !bookableServices.length) {
              saveDevisQuote(sec._hdPbQuote);
              window.location.href = '/pages/devis';
              return;
            }
            if (!state.packKey && state.serviceIds.length && q.subtotal < minAlacarte) {
              saveDevisQuote(sec._hdPbQuote);
              window.location.href = '/pages/devis';
              return;
            }

            resBtn.disabled = true;
            showPbError('');
            var variantPromises = [];
            var productHandles = [];
            if (state.packKey) {
              var packEntry = getCatalogPack(state.packKey, catalog);
              if (packEntry && packEntry.handle && !pbPackRequiresDevisPage(state.packKey, catalog)) {
                productHandles.push(packEntry.handle);
                variantPromises.push(resolveBookingVariantId(state.packKey, surfLabel, state.surfaceKey, catalog, null));
              }
            }
            bookableServices.forEach(function (sid) {
              var svc = catalogServiceById(catalog, sid);
              if (!svc || !svc.handle) return;
              productHandles.push(svc.handle);
              variantPromises.push(fetchShopifyProduct(svc.handle).then(function (p) {
                var v = pickVariantFromProduct(p, surfLabel);
                return v ? v.id : null; 
              }));
            });

            if (!variantPromises.length) {
              saveDevisQuote(sec._hdPbQuote);
              window.location.href = '/pages/devis';
              return;
            }

            Promise.all(variantPromises).then(function (results) {
              var redirect = results.find(function (r) { return r && r.redirect; });
              if (redirect) {
                window.location.href = redirect.redirect;
                return null;
              }
              var variantIds = results.filter(function (r) { return typeof r === 'number'; });
              if (!variantIds.length) throw new Error('Produit introuvable pour cette sélection.');
              var props = pbFormProps(fd, surfLabel);
              Object.assign(props, manualContactProps(catalog, productHandles[0]));
              return buildMultiCartItemsWithTravelFee(variantIds, q.subtotal, props, travelCfg);
            }).then(function (items) {
              if (!items) return null;
              return hdCartAddJson(items);
            }).then(function (data) {
              if (!data) return;
              if (data.status && data.description) throw new Error(data.description);
              window.location.href = '/checkout';
            }).catch(function (err) {
              resBtn.disabled = !pbCanReserve(buildQuoteLines(catalog), catalog);
              showPbError((err && err.message) || 'Impossible d\'ajouter au panier. Réessayez ou appelez-nous.');
            });
          });
        }
      });
    });
  }

  function initCardCarousels(root) {
    var scope = root || document;
    var selector = '.hd-pricing-grid, .ptd-grid, .pta-grid, .ptc-grid';
    scope.querySelectorAll(selector).forEach(function (track) {
      if (track.closest('.hd-carousel-shell')) return;

      var shell = document.createElement('div');
      shell.className = 'hd-carousel-shell';
      track.parentNode.insertBefore(shell, track);
      shell.appendChild(track);

      function makeArrow(direction, label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hd-carousel-arrow hd-carousel-arrow--' + direction;
        button.setAttribute('aria-label', label);
        return button;
      }

      var previous = makeArrow('prev', 'Voir la carte précédente');
      var next = makeArrow('next', 'Voir la carte suivante');
      shell.insertBefore(previous, track);
      shell.appendChild(next);

      function cardStep() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.82;
        var styles = window.getComputedStyle(track);
        return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 14);
      }

      function updateArrows() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        shell.classList.toggle('hd-carousel-shell--scrollable', max > 4);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4 || max <= 4;
      }

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      requestAnimationFrame(updateArrows);
    });
  }

  function initLegacyPricingLinks(root) {
    var redirects = {
      '/pages/copros-syndics': '/pages/tarifs#copropriete',
      '/pages/condos': '/pages/tarifs#copropriete',
      '/pages/copropriete': '/pages/tarifs#copropriete',
      '/pages/coproprietes': '/pages/tarifs#copropriete',
      '/pages/marchands-de-biens': '/pages/tarifs#marchands',
      '/pages/marchand-de-biens': '/pages/tarifs#marchands',
      '/pages/real-estate-traders': '/pages/tarifs#marchands'
    };

    var currentTarget = redirects[window.location.pathname.replace(/\/$/, '')];
    if (currentTarget) {
      window.location.replace(currentTarget);
      return;
    }

    (root || document).querySelectorAll('a[href]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        var target = redirects[url.pathname.replace(/\/$/, '')];
        if (target) link.setAttribute('href', target);
      } catch (error) {
        /* Ignore non-HTTP links such as tel: and mailto:. */
      }
    });
  }

  function initReservationEntryGuard() {
    if (document.documentElement.dataset.hdReservationEntryGuard) return;
    document.documentElement.dataset.hdReservationEntryGuard = '1';
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      if (link.classList.contains('hd-cart-property__edit')) return;
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== '/pages/prendre-rdv') return;
        if (url.searchParams.has('resume') || url.searchParams.has('selection')) return;
        url.searchParams.set('step', '1');
        url.searchParams.set('start', '1');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
        /* Ignore non-HTTP links. */
      }
    }, true);
  }

  function initAll(root) {
    initChecker(root);
    initAudienceTabs(root);
    initFaq(root);
    initReveal(root);
    initMobileMenu(root);
    initNavSubmenu(root);
    initSlider(root);
    initBooking(root);
    initPricingTabs(root);
    initPricingPills(root);
    initPricingBuilder(root);
    initPackCompare(root);
    initDevisWizard(root);
    initPickCards(root);
    initProductPage(root);
    initQuotePdf(root);
    initTravelFeeProductForms(root);
    initCardCarousels(root);
    initLegacyPricingLinks(root);
    initReservationEntryGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when a section is (re)rendered */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initFaq(e.target); });
})();
